import api from './../service/apiService'
import { apiUrl } from './../constants/apiUrl'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
import {
    CheckOut,
    Deposit,
    FinalBill,
    Pages,
    InstallationConstants,
    MTNValidation,
    PAGEACTIVITY,
    CheckLQ,
} from './../constants/actionType';
import * as saveAction from './save';
import { errorAction } from './error';
import { loaderActive } from './loder'
import { suppDueDateAvailable } from './supp';
import { redirectTo } from './redirection'
import { creditInfoUpdate } from './../service/aimsChat.js'
import { getCartHeader, getCartData } from './../util/cartUtility'
//import * as resp from './../containers/checkout/sampleCreditResponse'
//import * as duedatesample from './../containers/checkout/dueDataSampleJson'
import { updateSCcustomEvent, tempSCData, scDataDetails } from './../service/dtmTag';
import { updateVzdlSCCustomEvent, tempVzdlSCData, vzdlErrorUpdate, updateSandboxIdValue } from './../service/vzdl';
import { validateVZWOfferEligibility } from './loopQual';
import * as submitOrderAction from './submitOrder'
import { InHomeUtils } from './../util/inhomeUtils';
import * as moveExpAction from './moveExp'
import { logNRTime } from './../util/commonUtil';
import { store } from './../index'

let reserveDueDateAPICount = 0;
let getDueDatesAPICount = 0;
let setDueDateAPIFailCount = 0;
let setDueDateAPIRetryCount = 0;
let aemkeyvalue;
let noSSNcreditFailAttempts=0;

/* Checkout steps accordion */
export const gotoCheckoutStep = (stepNumber, dispatch) => {
    dispatch({
        type: 'GOTO_CHECKOUT_STEP',
        value: stepNumber
    })
}

export const updatePersonalInfoAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: action })
}
export const updateSatelliteAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateSatelliteAccordionStatus, value: action })
}
export const updateCreditCheckAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: action })
}
export const updateInstallationAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: action })
}
export const updateAutoPayAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateAutoPayAccordionStatus, value: action })
}
export const updateTOSAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateTosAccordionStatus, value: action })
}
export const updateDepositAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateDepositAccordionStatus, value: action })
}
export const onCreditStatusChange = (dispatch, creditFailAttempts,noSSNCheck) => {
    if(noSSNCheck){
        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
    }
    dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts })
    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
}

export const onUpdateCreditCheckBanner =  (dispatch,action) => {
    dispatch({type: CheckOut.isCreditCheckBannerStatus, value: action})
}

export const PrevSelectedProdAccordion = (SelectedProd, dispatch) => {
    dispatch({ type: CheckOut.PrevSelectedProd, value: SelectedProd })
}

export const paymentClicked = (status, dispatch) => {
    dispatch({ type: Deposit.depositPaymentClicked, value: status })
};

export const depositAddressCheck = (status, dispatch) => {
    dispatch({ type: Deposit.depositAddressCheck, value: status })
};

export const depositdebitCheck = (status, dispatch) => {
    dispatch({ type: Deposit.depositdebitCheck, value: status })
};


export const updateFinalBillOption = (dispatch, val) => {
    dispatch({ type: FinalBill.updateFinalBillOption, value: val })
}

export const finalBilldebitCheck = (status, dispatch) => {
    dispatch({ type: FinalBill.finalBilldebitCheck, value: status })
};

export const finalBillAddressCheck = (status, dispatch) => {
    dispatch({ type: FinalBill.finalBillAddressCheck, value: status })
};

export const updateSSNandDOBStatus = (ssnFilled, dobFilled, dispatch) => {
    dispatch({ type: CheckOut.updateSSNandDOBStatus, value: { dobFilled: dobFilled, ssnFilled: ssnFilled } })
}
export const setCartDirtyFlag = (status,dispatch) => {
    dispatch({ type: 'SET_CART_DIRTY', value: status })
}

export const onFinalBillContinueClick = (dispatch, val,visitId) => {
    if (val === 'success') {
        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })
    }
    if (val === 'No' || val === 'fail') {
        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
        dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
        dispatch({ type: CheckOut.updateRTAStatus, value: false })
        dispatch({ type: CheckOut.updateDepositInfo, value: false })
    }
    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.FB, PAGEACTIVITY.MSG.CD, PAGEACTIVITY.UA));
}

export const validateFinalBill = (action, dispatch) => {
    dispatch({
        type: FinalBill.validateFinalBill,
        value: action
    });
}
export const checkoutLoaded = (status, dispatch) => {
    getReserveFailMsg(dispatch);
    dispatch({ type: CheckOut.checkoutLoaded, value: status });
};

export const setFlowPurpose = (flowType, dispatch, visitId, visitorId) => {
    if (flowType && InHomeUtils.isNotEmpty(flowType) && visitId && visitorId) {
        const updateFlowTypeUrl = apiUrl().updateFlowType;
        let request = JSON.stringify({ flowType });
        let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
        api(updateFlowTypeUrl, 'POST', request).then(response => {
            if ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                (response.meta.code === 200 || response.meta.code === 200.01))) {
                dispatch({ type: "UPDATE_FLOWTYPE", value: { flowType: flowType } });
                logKafka("ERROR", "LoopQual", "CheckFlowTypeChanges" + "_" + flowType, getErrorLogUrl, "applogs", visitId, "try");
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                response.meta.code === 500.01) {
                loaderActive({ isLoaderActive: false }, dispatch)
            }
            else {                 
                logKafka("ERROR", "LoopQual", "SystemError" + response + "_" + flowType, getErrorLogUrl, "applogs", visitId);
                loaderActive({ isLoaderActive: false }, dispatch)
            }
            
        })
            .catch(error => {                    
                logKafka("ERROR", "LoopQual", error.message, getErrorLogUrl, "applogs", visitId);
                loaderActive({ isLoaderActive: false }, dispatch)
            });
    }
}

export const getReserveFailMsg = (dispatch) => {
    let reservemsgURL = apiUrl().runtimeValuesUrl + 'reservefailmsg';

    try{
        // Initialize flag
        let flag = false;
        api(reservemsgURL, 'GET', '').then(response => {
            // In the API's response, set the flag to true
            flag = true;
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                aemkeyvalue = response.data;
            }
            else{
                aemkeyvalue ="arrivals is not available for the selected time slots,requestduedate cannot be before the current date,requested date is not available,closed-bucket capacity";

            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
        setTimeout(function () {
            if (flag == false) {
                aemkeyvalue ="arrivals is not available for the selected time slots,requestduedate cannot be before the current date,requested date is not available,closed-bucket capacity";
            }
        }, 10000);
       
    }
    catch (ex) {
        catchJSException('Checkout',this.props.appState.visitId,'getReserveFailMsg',ex);
    }
}
export const updateInstallation = async (visitId, installType, dispatch) => {
    try {
        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let request = getInstallTypeRequest(installType);
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent,visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent,visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                }); 
            }
            else{
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.CART,'CART Intent Error',PAGEACTIVITY.UA));
            } 
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:updateInstallation,errorMessage:${error.message}`;
               // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('Checkout',this.props.appState.visitId,'updateInstallation',ex);
    }
}

const getInstallTypeRequest = (installType) => {
    try {
        let request = {
            key: InstallationConstants.key,
            value: installType === "O" ? InstallationConstants.techInstall : InstallationConstants.selfInstall,
            action: "add"
        }
        return JSON.stringify(request)
    }
    catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'getInstallTypeRequest', ex);
    }
}


export const doValidateCart = (visitId, dispatch, pageName = 'BuildProduct', flowType = null, action = "",buildProduct) => {
    let isMnHAuthenticated = ""
    if(buildProduct?.internet?.mnhSignupIndicator !== "" && buildProduct?.internet?.mnhSignupIndicator !== null && buildProduct?.internet?.mnhSignupIndicator !== undefined){
        isMnHAuthenticated = buildProduct?.internet?.mnhSignupIndicator
      }
      let query = (isMnHAuthenticated ==='Y') ? '?isMnH=Y' : (isMnHAuthenticated ==='N') ? '?isMnH=N' : ""

    try
    {
        logOtherInfo(detailsInfo(pageName, visitId, 'doValidateCart', "Inside doValidateCart")); 
        let validateCart = apiUrl().validatecartUrl + visitId + query;
        dispatch({ 
            type: 'LOADER_ACTIVE', 
            value: { isLoaderActive: true, isLoaderText: "Checking out your cart", isLoaderImg: "loader" } 
        });
        setCartDirtyFlag(false,dispatch);
        api(validateCart, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: 'CO_VALIDATE_CART_SUCCESS',
                    value: "ValidateCart Success"
                });
                if(response.data && response.data.autoPayExists && response.data.autoPayExists == 'Y'){
                    dispatch({
                        type: 'CO_VALIDATE_CART_SUCCESS',
                        value : {skipAutoPay : true, required: true},
                    }); 
                } 
                if(response.data && response.data?.otcPriceExists != null && response.data?.otcPriceExists != undefined){
                    dispatch({
                        type: 'SETUP_FEE',
                        value : response.data.otcPriceExists,
                    }); 
                }
                // //Two Tabs Issue cart getting empty object 
                // if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.tierPricing) && InHomeUtils.isNotNull(response.data.tierPricing.tierContent) &&
                //     response.data.tierPricing.tierContent[0].monthlyRcPrice === "$0.00") {
                //     dispatch ({ type: BuildProduct.clearBuildProductState, value: "" });  
                //     dispatch ({ type: CartActions.clearCartState, value: "" });  
                //     redirectTo(Pages.BuildProduct, dispatch);
                // } 
                if(action !== 'Streamline') {
                    if(pageName==='SUPP-LANDING' || ((!flowType || flowType !== "SUPP") && pageName !=='CheckOut')) {
                        let flowTypeVal = store && store.getState().app && store.getState().app.flowType;
                         if(flowTypeVal!='MV'){
                             dispatch({type: 'UPDATERESKIN', value: true});
                         }
                         if((flowTypeVal !== "MV" && flowTypeVal !== "SUPP" && flowTypeVal !== "AF")  || (flowTypeVal !== "MV" && flowTypeVal !== "SUPP" && action==="minicart" && flowTypeVal !== "AF") || (flowTypeVal === "MV" && (action==="movescart" || action ==="minicart"))){
                             
                                 redirectTo(Pages.orderSummary, dispatch);
                             
                         } else {
                                 redirectTo(Pages.Checkout, dispatch)
                             
                         }
                     }
                }             
               
            }
            //Failure Case
            else if ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&  InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '500')) || (InHomeUtils.isNotNull(response) && response.status && response.status === 500)) {
                dispatch({
                    type: 'CO_VALIDATE_CART_FAILURE',
                    value: "ValidateCart Failure"
                });
                errorAction("LBO", pageName, "VOFailed", "applogs", visitId, dispatch, true, "VOFailed");
                vzdlErrorUpdate(response.meta.code,"VOFailed");
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            if (window.nrTimeState && window.nrTimeState.fromTime) {
                logNRTime(window.nrTimeState,dispatch, 'Checkout');
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:doValidateCart,errorMessage:${error.message}`;
               // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("LBO", pageName, error.message, "applogs", visitId, dispatch, true, "VOFailed");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'doValidateCart', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const doValidateCartBeforeOrderSubmission = (visitId, visitorId, dispatch, isTargetOrdering, pfbautopay, flowType, returnEquip, mon,buildProduct) => {
    let isMnHAuthenticated = ""
    if(buildProduct?.internet?.mnhSignupIndicator !== "" && buildProduct?.internet?.mnhSignupIndicator !== null && buildProduct?.internet?.mnhSignupIndicator !== undefined){
        isMnHAuthenticated = buildProduct?.internet?.mnhSignupIndicator
      }
      let query = (isMnHAuthenticated ==='Y') ? '?isMnH=Y' : (isMnHAuthenticated ==='N') ? '?isMnH=N' : ""

    let vtpRedirection = false;
    try
    {
        var didSucceed = false;
        let validateCart = apiUrl().validatecartUrl + visitId + query;
        dispatch({ 
            type: 'LOADER_ACTIVE', 
            value: { isLoaderActive: true, isLoaderText: "Checking out your cart", isLoaderImg: "loader" } 
        });
        setCartDirtyFlag(false,dispatch);
        api(validateCart, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')){
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "VOBEFORESUBMIT-SUCCESS", PAGEACTIVITY.UA));
                dispatch({
                    type: 'CO_VALIDATE_CART_SUCCESS',
                    value: "ValidateCart Success"
                });
                didSucceed = true;
            }
            //Failure Case
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "VOBEFORESUBMIT-FAILED", PAGEACTIVITY.UA));
                dispatch({
                    type: 'CO_VALIDATE_CART_FAILURE',
                    value: "ValidateCart Failure"
                });
                let EnableVTPVisitIdFix = store && store.getState() && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.EnableVTPVisitIdFix;
                if(EnableVTPVisitIdFix === 'Y') {
                vtpRedirection  = true;
                window.localStorage.clear();
                window.sessionStorage.clear();
                redirectTo(Pages.CheckLQVTPVisitIdEmpty, dispatch);
                }
            }
            else{
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "VOBEFORESUBMIT-FAILED-OTHER", PAGEACTIVITY.UA));
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            if (window.nrTimeState && window.nrTimeState.fromTime) {
                logNRTime(window.nrTimeState, this.props.dispatch, 'Checkout');
            }
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "SUBMITORDER-CALLED", PAGEACTIVITY.UA));
            submitOrderAction.doSumbitOrder(visitId, visitorId, dispatch, isTargetOrdering, pfbautopay, flowType, returnEquip, mon)
        })
            .catch(error => {
                if(vtpRedirection  === false) {
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:doValidateCartBeforeOrderSubmission,errorMessage:${error.message}`;
               // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "SUBMITORDER-CALLED-EXCEPTIONBLOCK", PAGEACTIVITY.UA));
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                submitOrderAction.doSumbitOrder(visitId, visitorId, dispatch, isTargetOrdering, pfbautopay,flowType, returnEquip, mon)
                } else {
                    redirectTo(Pages.CheckLQVTPVisitIdEmpty, dispatch); 
                }
                
            });
    }
    catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'doValidateCartBeforeOrderSubmission', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

//begin installation
export const setInstallDate = (selInstallDate, selInstallDateFormatted, dispatch) => {
    dispatch({
        type: 'SET_INSTALL_DATE',
        value: {
            selInstallDate: selInstallDate,
            selInstallDateFormatted: selInstallDateFormatted
        }
    });

};
export const setSwitchInstallOptions = (status, dispatch,type) => {
    dispatch({ type: 'SET_SWITCHINSTALL_OPTIONS', value: status })
    dispatch({ type: 'CHANGE_INSTALL_CALENDAR_VEC', value: type});
};

export const setDisconnectDate = (selDiscDate, selDiscDateFormatted, dispatch) => {
    dispatch({
        type: 'SET_DISCONNECT_DATE',
        value: {
            selDiscDate: selDiscDate,
            selDiscDateFormatted: selDiscDateFormatted
        }
    });

};

export const updateAvailableDisconnectDates = (disconnectDates, dispatch) => {
    dispatch({
        type: 'UPDATE_AVAILABLE_DISC_DATES',
        value: disconnectDates
    });

    dispatch({
        type: 'CLEAR_SELECTED_DISC_DATE',
        value: ""
    });
};

export const updateTimeSlots = (selInstallDate, dueDateResponse, dispatch,visitId) => {
    let timeSlots = [];
    try{

    let dueDateIndex = dueDateResponse.findIndex(el => el.dueDate === selInstallDate);

   if (dueDateIndex >= 0 && InHomeUtils.isNotNull(dueDateResponse[dueDateIndex].timeInterval)) {
       dueDateResponse[dueDateIndex].timeInterval.forEach(el => timeSlots.push({ displayTime: el.displayTime, reserveTime: el.reserveTime }));
   }

   if(InHomeUtils.isNotNull(timeSlots) && timeSlots.length>0)
   {
    dispatch({
        type: 'UPDATE_TIME_SLOTS',
        value: timeSlots
    });
}
}
    catch (ex) {
        catchJSException('Checkout', visitId, 'action_updateTimeSlots', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

export const setInstallTimeSlot = (reserveTime, displayTime, dispatch) => {
    dispatch({
        type: 'SET_INSTALL_TIME_SLOT',
        value: { reserveTime: reserveTime, displayTime: displayTime }
    });
}

export const changeCalendar = (equipmentDelivery, dispatch) => {
    let value;

    switch (equipmentDelivery) {
        case 'pickUp':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "PickUp"
            };
            break;
        case 'mailEquipment':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "Mail"
            };
            break;
        case 'priorityShip':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "PriorityShipping"
            };
            break;
        case 'sameDayDelivery':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "SDD"
            };
            break;
        case 'packageLocker':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "Locker"
            };
            break;
        default:
            break;
    }

    dispatch({
        type: 'CHANGE_INSTALL_CALENDAR',
        value: value
    });
};

export const toggleDirectShipSection = (showDirectShip, dispatch) => {
    dispatch({
        type: 'TOGGLE_DIRECT_SHIP_SECTION',
        value: showDirectShip
    })
};

export const setDirectShipEarliestDate = (earliestDate, dispatch) => {
    dispatch({
        type: 'SET_DIRECT_SHIP_EARLIEST_DATE',
        value: earliestDate
    })
};

export const setDirectShipSelection = (directShipSel, dispatch) => {
    dispatch({
        type: 'SET_DIRECT_SHIP_SELECTION',
        value: directShipSel
    })
};

//installation API
/*const dueDateSubmitRequest = (selectedDate) => {
    let request = {
        date: selectedDate,
        isSDDOpted: false,
        shipping: {
            name: "standard",
            price: "$0.0"
        },
        arrivalTime: "0800-1200",
        directShip: "Y"
    };
    return JSON.stringify(request);
}*/

export const setDueDate = async (duedatereq, dispatch, visitId,servicesOrdered,PrevSelectedProudct,autoPay,resetDDattemptExceeded,satelliteEligible,satelliteSelect, flowType, baseOrderDetail=null, fiosInABox,enablePFBautoPayReskin,techY=null, isAutopayPFBEnhancement = false) => {
    try
    {
        const getDueDateApiCount = store?.getState()?.loopQual?.runtimeKey?.getDueDateApiCount ? parseInt(store?.getState()?.loopQual?.runtimeKey?.getDueDateApiCount) : 3;
        const tech = techY && '?tech=' +techY || '';   
        let url = apiUrl().setDueDate + tech;
        dispatch({ 
            type: 'LOADER_ACTIVE', 
            value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" } 
        });
        reserveDueDateAPICount = reserveDueDateAPICount + 1;
        return api(url, 'POST', duedatereq).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatchSDDEvents(dispatch,autoPay, servicesOrdered,PrevSelectedProudct,visitId,enablePFBautoPayReskin, isAutopayPFBEnhancement);
                
            }
            else
            {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && 
                    (InHomeUtils.getIndexOf(response.meta.code, '400') || InHomeUtils.getIndexOf(response.meta.code, '500')) && setDueDateAPIFailCount > 3) {
                        setDueDateAPIFailCount = setDueDateAPIFailCount + 1;
                        setDueDate(duedatereq, dispatch, visitId,servicesOrdered,PrevSelectedProudct,autoPay,resetDDattemptExceeded,satelliteEligible,satelliteSelect, flowType, baseOrderDetail=null, fiosInABox);
                }
                if(!resetDDattemptExceeded)
                {
                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.description) && response.meta.description !== "" &&
                    reserveFailMatch(response.meta.description)){
                        
                        dispatch({
                            type: 'RESET_DUEDATE',
                            value:''
                        });
        
                        dispatch({
                            type: 'RESET_DUEDATE_MESSAGE',
                            value:{
                                resetDD :true,
                                attemptExceeded:true
                            }
                        });
        
                        if (satelliteEligible === "N") {                            
                            try {
                                if (setDueDateAPIRetryCount < getDueDateApiCount) {
                                    getDueDates(dispatch,visitId,'', flowType, baseOrderDetail, fiosInABox);
                                    setDueDateAPIRetryCount = setDueDateAPIRetryCount + 1;
                                }
                            }
                            catch (ex) {
                                catchJSException('Checkout', visitId, 'setDueDate_Retry', ex);
                                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            }                            
                        }      
                        else if (satelliteEligible === "Y" && (InHomeUtils.isNotNull(satelliteSelect) && satelliteSelect !== '') ){
                            try {
                                if (setDueDateAPIRetryCount < getDueDateApiCount) {
                                    getDueDates(dispatch,visitId,satelliteSelect, flowType, baseOrderDetail, fiosInABox);
                                    setDueDateAPIRetryCount = setDueDateAPIRetryCount + 1;
                                }
                            }
                            catch (ex) {
                                catchJSException('Checkout', visitId, 'setDueDate_Retry', ex);
                                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            }
                        }
                    }
                }
                else{

                    dispatchSDDEvents(dispatch,autoPay,servicesOrdered,PrevSelectedProudct,visitId,enablePFBautoPayReskin, isAutopayPFBEnhancement);
                }

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'RESERVE Date API Error',PAGEACTIVITY.UA));
                
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return true;
        }).catch(error => {
            if (!resetDDattemptExceeded && reserveDueDateAPICount < getDueDateApiCount) {
                dispatch({
                    type: 'RESET_DUEDATE',
                    value: ''
                });
                dispatch({
                    type: 'RESET_DUEDATE_MESSAGE',
                    value: {
                        resetDD: true,
                        attemptExceeded: true
                    }
                });
                if (satelliteEligible === "N") {
                    // getDueDates(dispatch, visitId, '', flowType, baseOrderDetail, fiosInABox);
                    try {
                        if (setDueDateAPIRetryCount < getDueDateApiCount) {
                            getDueDates(dispatch, visitId, '', flowType, baseOrderDetail, fiosInABox);
                            setDueDateAPIRetryCount = setDueDateAPIRetryCount + 1;
                        }
                    }
                    catch (ex) {
                        catchJSException('Checkout', visitId, 'setDueDate_CatchBlock_Retry', ex);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }   
                }
                else if (satelliteEligible === "Y" && (InHomeUtils.isNotNull(satelliteSelect) && satelliteSelect !== '')) {
                    //getDueDates(dispatch, visitId, satelliteSelect, flowType, baseOrderDetail, fiosInABox);
                    try {
                        if (setDueDateAPIRetryCount < getDueDateApiCount) {
                            getDueDates(dispatch, visitId, satelliteSelect, flowType, baseOrderDetail, fiosInABox);
                            setDueDateAPIRetryCount = setDueDateAPIRetryCount + 1;
                        }
                    }
                    catch (ex) {
                        catchJSException('Checkout', visitId, 'setDueDate_CatchBlock_Retry', ex);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }   
                }
            }
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:setDueDate,errorMessage:${error.message}`;
           // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            logKafka("ERROR", "SETDUEDATE", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return false;
        });
    }
    catch(ex)
    {
        catchJSException('Checkout',visitId,'setDueDate',ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        return false;
    }
}
export const reserveFailMatch = (data) => {
    let reservefail = false;
    if (InHomeUtils.isNotNull(data) && data !== "") {
        //let aemkeyvalue = "arrivals is not available for the selected time slots,requestduedate cannot be before the current date,requested date is not available,closed-bucket capacity";
        aemkeyvalue.split(',').forEach((el) => {
            if (data.toLowerCase().indexOf(el) > -1)
            {
                reservefail = true;

            }
        });

    }
    return reservefail;
}
export const getDueDates = (dispatch, visitId, satelliteSelect,flowType,baseOrderDetail=null,fiosInABox, techY = null ) => {
    try
    {
    const fiosinABox =  '&tempDispatch=' + (fiosInABox && 'YES' || 'NO');
    const tech = techY && '&tech=' +techY || '';
    let url = apiUrl().getDueDate + "?satellite=" + satelliteSelect+ "&appId=" +flowType + fiosinABox  + tech;
    dispatch({ 
        type: 'LOADER_ACTIVE', 
        value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" } 
    });
    //let installoptions =""; //scDataDetails.initialInstallOptions
    let strdaysgapformat = "fios:";
    let noofdays="";
    let dt2 = new Date();
    let dt1="";
    //var pickupDD = require('./../containers/checkout/pickupDD.json'); 
    
    api(url, 'GET', '').then(response => {
        //response = duedatesample.dueDateResp;
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
            //response = pickupDD;
            response.data={...response.data,tech:techY, flowType:flowType}
            console.log('due date response',response)
            dispatch({
                type: CheckOut.onDueDateSuccess,
                // value: response.data //duedatesample.dueDateResp
                value: response.data  
            });
            if(fiosInABox && !window.sessionStorage.getItem('fiosInABox')){
                window.sessionStorage.setItem('fiosInABox', response.data.intervalReason || 'N');
            }
            if(response.data && response.data.covidRestriction) {
                dispatch({
                    type: 'DUEDATE_COVID_RESTRICTION',
                    value: response.data.covidRestriction
                })
            }
            //movechange
            if(flowType=='MV'){
                moveExpAction.getViewdetailsExperience(dispatch, visitId);
            }
            // else{
            // updateInstallation(visitId, response.data.dispatchType, dispatch);
            // }
            if(response.data.dispatchType === "O" ){
                strdaysgapformat = strdaysgapformat + "freetech";
                if(response.data.duedates[0].directShip ==="Y"){
                    strdaysgapformat = strdaysgapformat + "+ directship ";
                }
                dt1 = new Date(response.data.duedates[0].dueDate);
            }           
            
            if (response.data.dispatchType === "I" && response.data.shipping[1]) {
                url = apiUrl().storePickUp;
                api(url, 'GET', '').then(strPkpResponse => {
                    //response = duedatesample.storepickupdata;
                    let spproduct = [];
                    let plproduct = [];
                    if (InHomeUtils.isNotNull(response)  && InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.getClosestInvAvailabilityLoc) && strPkpResponse.response.getClosestInvAvailabilityLoc.record) {
                        strPkpResponse.response.getClosestInvAvailabilityLoc.record.map(obj => {
                            if (obj.type === "VZMDU") { //Package Locker Stores
                                return (
                                    plproduct.push({ addressL1: obj.store.location.addressline1, addressL2: `${obj.store.location.city} ${obj.store.location.state} ${obj.store.location.zip}`, distance: obj.store.approxmiles, contactNo: obj.store.telephone, openHrs: obj.store.operatinghours1 }))
                            }
                            else {
                                return (
                                    spproduct.push({ addressL1: obj.store.location.addressline1, addressL2: `${obj.store.location.city} ${obj.store.location.state} ${obj.store.location.zip}`, distance: obj.store.approxmiles, contactNo: obj.store.telephone, openHrs: obj.store.operatinghours1 }))
                            }
                        })
                    }
                    strdaysgapformat = strdaysgapformat + "selfstoreormail" ;  
                    dt1 = new Date(response.data.duedates[0].dueDate);                  
                    dispatch({
                        type: CheckOut.updateStorePickUpData,
                        value: spproduct
                    });
                    if (plproduct.length > 0) {
                        dispatch({
                            type: CheckOut.updatePackageLockerData,
                            value: plproduct
                        });
                    }
                })
                url = apiUrl().getDueDate +"?satellite=&triggerShipCall=Y"+ "&appId=" +flowType + fiosinABox;
                //var mailDDJson = require('./../containers/checkout/mailDD.json'); 
                api(url, 'GET', '').then(response => {
                    //response = duedatesample.dueDateResp;
                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                        //response = mailDDJson;
                        dispatch({
                            type: CheckOut.onDueDateSuccess,
                            value: response.data //duedatesample.dueDateResp 
                        });
                        if(fiosInABox && !window.sessionStorage.getItem('fiosInABox')){
                            window.sessionStorage.setItem('fiosInABox', response.data.intervalReason || 'N');
                        }
                        if(response.data && response.data.covidRestriction) {
                            dispatch({
                                type: 'DUEDATE_COVID_RESTRICTION',
                                value: response.data.covidRestriction
                            })
                        }
                        //movechange
                        if(flowType=='MV'){
                            moveExpAction.getViewdetailsExperience(dispatch, visitId);
                        }else{
                        updateInstallation(visitId, response.data.dispatchType, dispatch);
                        }
                        dt1 = new Date(response.data.duedates[0].dueDate);
                        dispatch({
                            type: 'CHANGE_INSTALL_CALENDAR',
                            value: {
                                selDueDateType: "EONTSELFINSTALL",
                                selDeliveryOption: "PickUp"
                            }
                        })
                    }
                    else{
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'GET DUE DATE Failure',PAGEACTIVITY.UA));
                    } 
                });
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.dispatchType) && response.data.dispatchType === "I"){
                strdaysgapformat = strdaysgapformat + "self" ;
                dt1 = new Date(response.data.duedates[0].dueDate);
            }

            noofdays = dt1 && Math.floor((Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) - Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate())) / (1000 * 60 * 60 * 24));

            strdaysgapformat += "^ " + noofdays + "d | _";
            scDataDetails.initialInstallOptions = strdaysgapformat;
            if(flowType=="SUPP" && InHomeUtils.isNotNull(baseOrderDetail)&& InHomeUtils.isNotNull(baseOrderDetail.vzOrder)){
                let isdueDateAvail = false;
                if(response.data.dispatchType==="O" && baseOrderDetail.vzOrder.duedateOption==="F"){
                    isdueDateAvail=true;
                }
                else if(response.data.dispatchType!=="O" && baseOrderDetail.vzOrder.duedateOption!=="F"){
                    isdueDateAvail=true;
                }
                else{
                    if((response.data.dispatchType!=="O" && baseOrderDetail.vzOrder.duedateOption==="F") || (response.data.dispatchType==="O" && baseOrderDetail.vzOrder.duedateOption!=="F")){
                        isdueDateAvail=false;
                    }
                }
                if (isdueDateAvail) {
                    response.data.duedates.map(obj => {
                        if (obj.duedate === baseOrderDetail.vzOrder.duedate && !isdueDateAvail) {
                            isdueDateAvail = true;                            
                        }
                    })
                    if (isdueDateAvail) {
                        response.data.duedates.map(obj => {
                            if (obj.reserveTime === baseOrderDetail.vzOrder.dispatchInfo && !isdueDateAvail) {
                                isdueDateAvail = true;
                            }
                        })
                    }
                }
                suppDueDateAvailable(isdueDateAvail?"Y":"N", dispatch);
            }
        }
        else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta)
            && InHomeUtils.getIndexOf(response.meta.code, '400') && InHomeUtils.isNotNull(response.meta.description === "Due Date Response Failed.")) {
            try {
                if (getDueDatesAPICount < 3) {
                    getDueDates(dispatch, visitId, satelliteSelect, flowType, baseOrderDetail, fiosInABox);
                    getDueDatesAPICount = getDueDatesAPICount + 1;
                }
            }
            catch (ex) {
                catchJSException('Checkout', this.props.appState.visitId, 'getDueDates_Description', ex);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        }
        else{
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'GET DUE DATE Failure',PAGEACTIVITY.UA));
            if(flowType=="SUPP" && InHomeUtils.isNotNull(baseOrderDetail)&& InHomeUtils.isNotNull(baseOrderDetail.vzOrder)){
                suppDueDateAvailable("FAILED", dispatch);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'GET DUE DATE Failure-SUPP',PAGEACTIVITY.UA));
            }
        }        

        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    })
        .catch(error => {
            if(getDueDatesAPICount < 3) {
                getDueDates(dispatch, visitId, satelliteSelect,flowType,baseOrderDetail,fiosInABox);
                getDueDatesAPICount = getDueDatesAPICount +1;
            }
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:getDueDates,errorMessage:${error.message}`;
           // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            logKafka("ERROR", "DUEDATE", errorMsg, getErrorLogUrl, "applogs", visitId);
            if(flowType=="SUPP" && InHomeUtils.isNotNull(baseOrderDetail)&& InHomeUtils.isNotNull(baseOrderDetail.vzOrder)){
                suppDueDateAvailable("FAILED", dispatch);
            }
        });
    }
    catch(ex)
    {
        if(getDueDatesAPICount < 3) {
            getDueDates(dispatch, visitId, satelliteSelect,flowType,baseOrderDetail,fiosInABox);
            getDueDatesAPICount = getDueDatesAPICount +1;
        }
        catchJSException('Checkout',this.props.appState.visitId,'getDueDates',ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

export const requestCallback = (dispatch, visitId) => {
    try {
        let url = apiUrl().requestCallback;
        let kafkaPageLogs = apiUrl().kafkaPageLogs;
        api(url, 'GET', '').then(response => {
            logKafka("INFO", "Checkout", response.data, kafkaPageLogs, "applogs", visitId);
        })
    }
    catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'CallBack', ex);
    }
}

export const sameDayDelivery = (dispatch, visitId) => {
    try
    {
    let url = apiUrl().sameDaydelivery;
    api(url, 'GET', '').then(response => {
        //response={"meta":{"code":201.01,"description":"Same day delivery successful","timestamp":"Wed Dec 12 06:24:41 UTC 2018"},"data":{"prismShippingOptions":[{"shippingoption":"SAME_DAY","valid":"YES"}]}};         
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '201')) {

            let isSDD =  (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.prismShippingOptions)
                && response.data.prismShippingOptions.length > 0 && response.data.prismShippingOptions[0].valid.toLowerCase() === "yes") ? true : false
            dispatch({
                type: CheckOut.updateSameDayDelivery,
                value: isSDD
            });

            if (isSDD) {
                dispatch({
                    type: 'CHANGE_INSTALL_CALENDAR',
                    value: {
                        selDueDateType: "EONTSELFINSTALL",
                        selDeliveryOption: "SDD"
                    }
                })
            }

        }
        else {
            dispatch({
                type: CheckOut.updateSameDayDelivery,
                value: false
            })
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'SameDayDelivery API Failure',PAGEACTIVITY.UA));
        }
    })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:sameDayDelivery,errorMessage:${error.message}`;
            //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            logKafka("ERROR", "SAMEDAYDELIVERY", errorMsg, getErrorLogUrl, "applogs", visitId);
        });
    }
    catch(ex)
    {
        catchJSException('Checkout',this.props.appState.visitId,'sameDayDelivery',ex);
    }
}

//end installation

export const tosCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.tosChecked, value: status })
};
export const homeSecurityCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.homeSecurityChecked, value: status })
};
export const homeSecureCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.homeSecureChecked, value: status })
}

export const homeSecurePlusCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.homeSecurePlusChecked, value: status })
}
export const hdpCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.hdpChecked, value: status })
};
export const ftcCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.ftcChecked, value: status })
};

export const tosVoiceCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.tosVoiceChecked, value: status })
};

export const tosViewed = (status, dispatch) => {
    dispatch({ type: CheckOut.tosViewed, value: status })
};

export const checkExternalCreditCheck = (dispatch) => {
    dispatch({ type: CheckOut.onUpdateExternalCreditCheck, value: '' })
};

export const disableExternalCreditCheck = (dispatch) => {
    dispatch({ type: CheckOut.disableExternalCreditCheck, value: '' })
};
export const noSSNCheck = (dispatch) => {
    dispatch({ type: CheckOut.noSSNCheck, value: '' })
};

export const disableSSNCheck = (dispatch) => {
    dispatch({ type: CheckOut.disableSSNCheck, value: '' })
};

export const enableSSNCheck = (dispatch) => {
    dispatch({ type: CheckOut.enableSSNCheck, value: '' })
};


/* PaperFreeBilling and AutoPay Start Here */
export const ContinueClick = (action, dispatch) => {
    dispatch({
        type: CheckOut.onPFBClick,
        value: action
    });
};
export const PaymentModeChanges = (action, dispatch) => {
    dispatch({
        type: CheckOut.onPaymentModeChange,
        value: action
    });
};
export const CheckAutoPayOffer = (action, dispatch) => {
    dispatch({
        type: CheckOut.onCheckAutoPayOffer,
        value: action
    });
};

export const updateChoice = (dispatch, value) => {
    dispatch({
        type: CheckOut.updateRTAChoice,
        value: value
    });
}

export const performEID = (dispatch, request, creditFailAttempts, isFCPflow, isDoFlow,noSSNCheck=false) => {
    try
    {
    let url = apiUrl().performEID;
    dispatch({ 
        type: 'LOADER_ACTIVE', 
        value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" } 
    });
    api(url, 'POST', JSON.stringify(request)).then(response => {
        if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code)) {

            dispatch({ type: CheckOut.updateRTAStatus, value: false })
            dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
            if(InHomeUtils.isNotNull(response.data) &&  InHomeUtils.isNotNull(response.data.result) && InHomeUtils.isNotNull(response.data.result.reason)){
            if (response.data.result.reason === 'SUCCESS') {
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })

                if (response.data.icredit.depositinfo.depositamount > 0) {
                    dispatch({ type: CheckOut.updateDepositInfo, value: true })
                    dispatch({ type: CheckOut.updateDepositAmount, value: response.data.icredit.depositinfo.depositamount })
                }
                else{
                    dispatch({ type: CheckOut.updateDepositInfo, value: false })
                    dispatch({ type: CheckOut.updateDepositAmount, value: response.data.icredit.depositinfo.depositamount })
                }
                if(noSSNCheck){
                    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
                }
                else{
                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })
                }

                tempSCData.detailPageName = "accord| info and credit- crd chk pass";
                tempVzdlSCData.detail = "info and credit- crd chk pass";
                tempSCData.creditCheck = "Pass";                
                tempVzdlSCData.creditCheck = "Pass";   
                if (response.data.icredit.depositinfo.depositamount > 0) {
                    tempSCData.creditCheckstatus = "pass- deposit";
                    tempVzdlSCData.creditCheckstatus = "pass with deposit";
                }
                else{
                    tempSCData.creditCheckstatus = "pass- without deposit";
                    tempVzdlSCData.creditCheckstatus = "pass without deposit";
                }
                if (InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()) {
                    if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord seamless move";
                        tempVzdlSCData.flowName = "accord seamless move";
                    } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord seamless move| mix match";
                        tempVzdlSCData.flowName = "accord seamless move + mix match";
                    }
                    else {
                        tempSCData.flowName = "prospect accord seamless move";
                        tempVzdlSCData.flowName = "accord seamless move";
                    }
                    updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
                }
                else if (InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()) {
                    if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord move";
                        tempVzdlSCData.flowName = "accord move";
                    } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord move| mix match";
                        tempVzdlSCData.flowName = "accord seamless move mix match";
                    }
                    else {
                        tempSCData.flowName = "prospect accord move";
                        tempVzdlSCData.flowName = "accord move";
                    }
                    updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
                }
                else {
                    updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    setTimeout(()=>{
                        tempSCData.detailPageName = "accord| info and credit- crd chk pass";
                        tempVzdlSCData.detail = "info and credit- crd chk pass";
                        updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                    },1000); 
                }
                
                tempSCData.detailPageName = "accord| info and credit- crd chk rta success";
                tempVzdlSCData.detail = "info and credit- crd chk rta success";
                tempSCData.creditCheck = "Pass";
                tempVzdlSCData.creditCheck = "Pass";
                if (InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()) {
                    if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord seamless move";
                        tempVzdlSCData.flowName = "accord seamless move";
                    } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord seamless move| mix match";
                        tempVzdlSCData.flowName = "accord seamless move + mix match";
                    }
                    else {
                        tempSCData.flowName = "prospect accord seamless move";
                        tempVzdlSCData.flowName = "accord seamless move";
                    }
                    updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
                }
                else if (InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()) {
                    if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord move";
                        tempVzdlSCData.flowName = "accord move";
                    } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord move| mix match";
                        tempVzdlSCData.flowName = "accord seamless move + mix match";
                    }
                    else {
                        tempSCData.flowName = "prospect accord move";
                        tempVzdlSCData.flowName = "accord move";
                    }
                    updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
                }
                else {
                    updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    setTimeout(()=>{
                        tempSCData.detailPageName = "accord| info and credit- crd chk rta success";
                        tempVzdlSCData.detail = "info and credit- crd chk rta success";
                        updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                    },2500); 
                }
            }
            else if (response.data.result.reason === 'FAILURE') {
                dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts + 1 })
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
                dispatch({ type: CheckOut.updateDepositInfo, value: false })

                tempSCData.detailPageName = "accord| info and credit- crd chk fail";
                tempVzdlSCData.detail = "info and credit- crd chk fail";
                tempSCData.creditCheck = "Fail";               
                tempVzdlSCData.creditCheck = "Fail";  
                if (response.data.icredit.depositinfo.depositamount > 0) {
                    tempSCData.creditCheckstatus = "fail- deposit";
                    tempVzdlSCData.creditCheckstatus = "fail with deposit";
                }
                else{
                    tempSCData.creditCheckstatus = "fail- without deposit";
                    tempVzdlSCData.creditCheckstatus = "fail without deposit";
                }
                if(InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()){
                    if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord seamless move";
                        tempVzdlSCData.flowName = "accord seamless move";
                    } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord seamless move| mix match";
                        tempVzdlSCData.flowName = "accord seamless move + mix match";
                    }
                    else {
                        tempSCData.flowName = "prospect accord seamless move";
                        tempVzdlSCData.flowName = "accord seamless move";
                    }
                    updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
                }
                else if(InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()){
                    if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord move";
                        tempVzdlSCData.flowName = "accord move";
                    } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord move| mix match";
                        tempVzdlSCData.flowName = "accord seamless move + mix match";
                    }
                    else {
                        tempSCData.flowName = "prospect accord move";
                        tempVzdlSCData.flowName = "accord move";
                    }
                    updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
                }              
                else{
                    updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    setTimeout(()=>{
                        tempSCData.detailPageName = "accord| info and credit- crd chk fail";
                        tempVzdlSCData.detail = "info and credit- crd chk fail";
                        updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                    },1000); 
                }

                tempSCData.detailPageName = "accord| info and credit- crd chk rta fail";
                tempVzdlSCData.detail = "info and credit- crd chk rta fail";
                tempSCData.creditCheck = "Fail";
                tempVzdlSCData.creditCheck = "Fail";
                if (InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()) {
                    if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord seamless move";
                        tempVzdlSCData.flowName = "accord seamless move";
                    } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord seamless move| mix match";
                        tempVzdlSCData.flowName = "accord seamless move + mix match";
                    }
                    else {
                        tempSCData.flowName = "prospect accord seamless move";
                        tempVzdlSCData.flowName = "accord seamless move";
                    }
                    updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
                }
                else if (InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()) {
                    if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord move";
                        tempVzdlSCData.flowName = "accord move";
                    } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                        tempSCData.flowName = "prospect accord move| mix match";
                        tempVzdlSCData.flowName = "accord seamless move + mix match";
                    }
                    else {
                        tempSCData.flowName = "prospect accord move";
                        tempVzdlSCData.flowName = "accord move";
                    }
                    updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
                }
                else {
                    updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    setTimeout(()=>{
                        tempSCData.detailPageName = "accord| info and credit- crd chk rta fail";
                        tempVzdlSCData.detail = "info and credit- crd chk rta fail";
                        updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                    },2500); 
                }
            }
        }
    }
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

    })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:performEID,errorMessage:${error.message}`;
           // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch(ex)
    {
        catchJSException('Checkout',this.props.appState.visitId,'performEID',ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}


export const doNotCreditCheck = (dispatch) => {
    dispatch({ type: CheckOut.updateDepositInfo, value: true })
    dispatch({ type: CheckOut.updateDepositAmount, value: '' }) 
}

/* PaperFreeBilling and AutoPay End Here */

export const doCreditCheck = (visitId, dispatch, creditCheckEncryptedValue, noSSNCheck, lqState, saveState, creditFailAttempts, tcChatInfo, appData, checkExternalCreditCheck, buildProductState = null,isVasVzProtect=false, contactPhoneNo = null, reattempt = 0) => {
    try {
        let isFDVQualified = false;
        let creditCheck = apiUrl().creditCheck;
        let MTN = "";
        if (InHomeUtils.isNotNull(tcChatInfo) && InHomeUtils.isNotNull(tcChatInfo.contactInfo) && InHomeUtils.isNotNull(tcChatInfo.contactInfo.phoneNo)) {
            // MTN = tcChatInfo.contactInfo.phoneNo.ph1 + tcChatInfo.contactInfo.phoneNo.ph2 + tcChatInfo.contactInfo.phoneNo.ph3;
            MTN = tcChatInfo.contactInfo.phoneNo.ph1;
        }
        let request = getCreditRequest(creditCheckEncryptedValue, noSSNCheck, checkExternalCreditCheck);
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Getting your installation dates ", isLoaderImg: "loader" }
       });
        
        api(creditCheck, 'POST', request).then(response => {
            //response= resp.creditResponse;
            //movechange
            if(appData.flowType!="MV"){
                //Autosave must happen only when FDV is qualified. 
                if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.servicesQualified) && InHomeUtils.isNotNull(lqState.servicesQualified.isVoiceQualified)
                    && lqState.servicesQualified.isVoiceQualified && !buildProductState?.isACPFlag && !buildProductState?.isVZFwdFlag) {
                    saveAction.smartSave(dispatch, visitId, "passive", true, false, appData.mon_no, MTN, true, lqState.isFCPflow, lqState.doFlowDetails.isDoFlow, null);
                } 
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
               /* let check_reattempt = store.getState().loopQual?.runtimeKey?.reattempt ? store.getState().loopQual.runtimeKey.reattempt : 1
              // console.table(store.getState().loopQual.runtimeKey)
                if(reattempt < check_reattempt)
                {
                    reattempt = reattempt + 1
                    doCreditCheck(visitId, dispatch, creditCheckEncryptedValue, noSSNCheck, lqState, saveState, creditFailAttempts, tcChatInfo, appData, checkExternalCreditCheck, buildProductState,isVasVzProtect, contactPhoneNo, reattempt)
                    
                }  */
                dispatch({
                    type: CheckOut.onUpdateCreditCheck,
                    value: response.data
                })
                dispatch({
                    type: CheckOut.updateCRVNunmber,
                    value: response.data.icredit.icreditrefno
                })
                if (response.data.icredit.depositinfo.depositamount > 0) {
                    dispatch({ type: CheckOut.updateDepositInfo, value: true })
                    dispatch({ type: CheckOut.updateDepositAmount, value: response.data.icredit.depositinfo.depositamount })
                } else {
                    dispatch({ type: CheckOut.updateDepositInfo, value: false })
                    dispatch({ type: CheckOut.updateDepositAmount, value: response.data.icredit.depositinfo.depositamount })
                }
              if(InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.result) && InHomeUtils.isNotNull(response.data.result.reason)){
                if (response.data.result.reason === 'SUCCESS') {
                    if(typeof wirelineLpCreditCheck !== "undefined" && InHomeUtils.isNotNull(wirelineLpCreditCheck) )
                    { 
                        wirelineLpCreditCheck('creditPass');
                        wirelineLpCreditCheck('installation');
                    }

                    tempSCData.detailPageName = "accord| info and credit- crd chk pass";
                    tempVzdlSCData.detail = "info and credit- crd chk pass";
                    tempSCData.installOptions = scDataDetails.initialInstallOptions;
                    tempSCData.creditCheck = "Pass";                    
                    tempVzdlSCData.creditCheck = "Pass";   
                    if (response.data.icredit.depositinfo.depositamount > 0) {
                        tempSCData.creditCheckstatus = "pass- deposit";
                        tempVzdlSCData.creditCheckstatus = "pass with deposit";
                    }
                    else{
                        tempSCData.creditCheckstatus = "pass- without deposit";
                        tempVzdlSCData.creditCheckstatus = "pass without deposit";                        
                    }
                    if(InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()){
                        if ((InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow) && InHomeUtils.isFCPInProfile()) {
                            tempSCData.flowName = "prospect accord seamless move";
                            tempVzdlSCData.flowName = "accord seamless move";
                        } else if ((InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                            tempSCData.flowName = "prospect accord seamless move| mix match";
                            tempVzdlSCData.flowName = "accord seamless move + mix match";
                        }
                        else {
                            tempSCData.flowName = "prospect accord seamless move";
                            tempVzdlSCData.flowName = "accord seamless move";
                        }
                        updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
                    }
                    else if(InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()){
                        if ((InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow) && InHomeUtils.isFCPInProfile()) {
                            tempSCData.flowName = "prospect accord move";
                            tempVzdlSCData.flowName = "accord move";
                        } else if ((InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                            tempSCData.flowName = "prospect accord move| mix match";
                            tempVzdlSCData.flowName = "accord seamless move + mix match";
                        }
                        else {
                            tempSCData.flowName = "prospect accord move";
                            tempVzdlSCData.flowName = "accord move";
                        }
                        updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
                    }                   
                    else{
                        setTimeout(()=>{
                            tempVzdlSCData.detail = "info and credit- crd chk pass";
                            updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail,notification","","","","Good news! You're approved for Fios Home internet");
                        },1000);  
                        updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    }                    
                    dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
                    dispatch({type: CheckOut.isCreditCheckBannerStatus, value: true})
                    setTimeout(() => {
                        dispatch({type: CheckOut.isCreditCheckBannerStatus, value: false})
                    },7000)
                    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })
                    setTimeout(()=>{
                        let noOfInstallDays = "";
                        if(store && store.getState && store.getState().checkout){
                            let selDueDateType =  store.getState().checkout.selDueDateType? store.getState().checkout.selDueDateType : "";
                            let calenderDisplayArr = store.getState().checkout.calenderDisplayArr ? store.getState().checkout.calenderDisplayArr : [];
                            
                            if(calenderDisplayArr.length > 0){
                                try {
                                    let dt1 = new Date();
                                    let dt2 = new Date(calenderDisplayArr[0]);
                                    noOfInstallDays = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
                                    noOfInstallDays = noOfInstallDays.toString();
                                }
                                catch (ex) {
                                    console.log('Date difference Calculation Failed '+ ex.message);
                                }
                            }
                            if(selDueDateType  === "TECHVISIT"){
                                tempVzdlSCData.detail = "installation options - tech install";
                            }
                            else{
                                tempVzdlSCData.detail = "installation options - self install";
                            }
                        }
                        updateVzdlSCCustomEvent("pfbandAutoPayLoad", "pageViewOmni", "detail", false, "", false, "", "", noOfInstallDays);
                    },2500);   
                    tempSCData.detailPageName = "accord| install tos and summary| install";
                    updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "detailPageName");
                    // tempSCData.detailPageName = "accord| install tos and summary| install";
                    // updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "detailPageName");
                    // tempVzdlSCData.detail = "accord install tos and summary install";
                    // updateVzdlSCCustomEvent("pfbandAutoPayLoad", "pageViewOmni", "detail");
                    creditInfoUpdate("SUCCESS", tcChatInfo, response.data.icredit.icreditrefno);
                    dispatch({ type: 'CREDIT_FAILURE', value: false });
                    let addrID = (lqState.selectedUnit && lqState.selectedUnit.addressId
                        && lqState.selectedUnit.addressId!=="N") ? lqState.selectedUnit.addressId : lqState.selectedAdr && lqState.selectedAdr.addressID;
                    let hoaFlow = lqState && lqState.lqResponse && lqState.lqResponse.hoaFlag && lqState.lqResponse.hoaFlag === "Y";
                    if (!hoaFlow && !buildProductState.mobileandhomeEligible && response.data.icredit && response.data.icredit.wirelessInfo && response.data.icredit.wirelessInfo.strMTN) {
                        let strMTN = response.data.icredit.wirelessInfo.strMTN.split(',')[0];
                        if(strMTN && saveState && (!saveState.saveLqMtnInput || (saveState.saveLqMtnInput && saveState.saveLqMtnInput.replace(/-/g,'') !== strMTN)) && (contactPhoneNo && Object.values(contactPhoneNo).join('') !== strMTN)) {
                            validateVZWOfferEligibility(dispatch, strMTN, visitId, false, addrID, "", "", lqState.isFCPflow, lqState.doFlowDetails && lqState.doFlowDetails.isDoFlow, lqState, buildProductState,"creditCheck",response.data.firstName,response.data.lastName,response.data.eMail);
                        }
                    }
                    if(isVasVzProtect && InHomeUtils.isNotNull(response.data.icredit.wirelessInfo) && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo)  && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo.strVCustID) && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo.strVAccID)){
                        getWirelessProductsVasPromo(dispatch,visitId,response.data.icredit.wirelessInfo.strVCustID,response.data.icredit.wirelessInfo.strVAccID)
                    }
                }
                else if (response.data.result.reason === 'FAILURE') {
                    if(typeof wirelineLpCreditCheck !== "undefined" && InHomeUtils.isNotNull(wirelineLpCreditCheck) ) wirelineLpCreditCheck('creditFail');
                    dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts + 1 })
                    dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                    tempSCData.detailPageName = "accord| info and credit- crd chk fail";
                    tempVzdlSCData.detail = "info and credit- crd chk fail";
                    tempSCData.creditCheck = "Fail";                    
                    tempVzdlSCData.creditCheck = "Fail";  
                    if (response.data.icredit.depositinfo.depositamount > 0) {
                        tempSCData.creditCheckstatus = "fail- deposit";
                        tempVzdlSCData.creditCheckstatus = "fail with deposit";
                    }
                    else{
                        tempSCData.creditCheckstatus = "fail- without deposit";
                        tempVzdlSCData.creditCheckstatus = "fail without deposit";
                    }
                    if(InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()){
                        if ((InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow) && InHomeUtils.isFCPInProfile()) {
                            tempSCData.flowName = "prospect accord seamless move";
                            tempVzdlSCData.flowName = "accord seamless move";
                        } else if ((InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                            tempSCData.flowName = "prospect accord seamless move| mix match";
                            tempVzdlSCData.flowName = "accord seamless move + mix match";
                        }
                        else {
                            tempSCData.flowName = "prospect accord seamless move";
                            tempVzdlSCData.flowName = "accord seamless move";
                        }
                        updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
                    }
                    else if(InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()){
                        if ((InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow) && InHomeUtils.isFCPInProfile()) {
                            tempSCData.flowName = "prospect accord move";
                            tempVzdlSCData.flowName = "accord move";
                        } else if ((InHomeUtils.isNotNull(lqState.isFCPflow) && lqState.isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                            tempSCData.flowName = "prospect accord move| mix match";
                            tempVzdlSCData.flowName = "accord seamless move + mix match";
                        }
                        else {
                            tempSCData.flowName = "prospect accord move";
                            tempVzdlSCData.flowName = "accord move";
                        }
                        updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
                    }                   
                    else{
                        updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                        setTimeout(()=>{
                            tempVzdlSCData.detail = "info and credit- crd chk fail";
                            updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                        },1000); 
                    }   

                    //Check If Final Bill Required
                    if (response.data.icredit.depositinfo.finalbillamountrequired === "Y") {
                        dispatch({ type: CheckOut.updateFinalBillStatus, value: true })
                        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                    }
                    //if RTA Q's required                
                    else if (InHomeUtils.isNotNull(response.data.questionanswer) && response.data.questionanswer.length > 0) {
                        let rtadata = []
                        response.data.questionanswer.map(obj => { return rtadata.push({ questionnumber: obj.questionnumber, choicenumber: 0 }) })
                        dispatch({ type: CheckOut.updateRTAQs, value: { rtaquesionarrie: response.data.questionanswer, rtadata: rtadata } })
                        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                        dispatch({ type: CheckOut.updateRTAStatus, value: true })

                    }
                    else {
                        //dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'required' })
                        if(creditFailAttempts <= 2)
                        {
                            dispatch({ type: 'CREDIT_FAILURE', value: true });                            
                            dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                            dispatch({ type: CheckOut.updateDepositInfo, value: false })
                            setCheckoutNotificationDisplay(dispatch, true);
                        }
                        else{
                            dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts + 1 })
                            dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                            dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
                            dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                            dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })            
                            dispatch({ type: CheckOut.updateRTAStatus, value: false })
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'required' })
                            if(typeof wirelineLpCreditCheck !== "undefined" && InHomeUtils.isNotNull(wirelineLpCreditCheck) )
                            {
                                wirelineLpCreditCheck('installation');
                            }
                            dispatch({ type: 'CREDIT_FAILURE', value: true });
                            dispatch({ type: CheckOut.updateDepositInfo, value: false })
                        }
                    }
                    creditInfoUpdate("FAILURE", tcChatInfo, response.data.icredit.icreditrefno);
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.CC,'CREDIT CHECK FAILED_CNT:'+ creditFailAttempts,PAGEACTIVITY.UA));
                    if(((response.data.result.additionalinfo || '').includes("Address may be linked to fraudulent activity") || creditFailAttempts > 2  )) {
                        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' });
                        dispatch({ type: CheckOut.updateCreditFailAttempts, value: 3 });
                    }
                    if(isVasVzProtect && InHomeUtils.isNotNull(response.data.icredit.wirelessInfo) && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo)  && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo.strVCustID) && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo.strVAccID)){
                        getWirelessProductsVasPromo(dispatch,visitId,response.data.icredit.wirelessInfo.strVCustID,response.data.icredit.wirelessInfo.strVAccID)
                    }
                    if(!noSSNCheck){
                        updateVzdlSCCustomEvent("checkoutInit", "sendData", "notification,detail", false, "", false, "You've entered an invalid social security number");
                    }
                }
            }
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.result) && InHomeUtils.isNotNull(response.data.result.reason) && response.data.result.reason === "FAILURE" && response.data.result.additionalinfo && (response.data.result.additionalinfo.toLowerCase().indexOf("security freeze") > -1 || response.data.result.additionalinfo.toLowerCase().indexOf("frozen file") > -1)) {
                dispatch({ type: CheckOut.updateCreditFailAttempts, value: 1 })
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
                dispatch({ type: CheckOut.updateRTAStatus, value: false })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'required' })
                if(typeof wirelineLpCreditCheck !== "undefined" && InHomeUtils.isNotNull(wirelineLpCreditCheck) )
        {
            wirelineLpCreditCheck('installation');
        }
                dispatch({ type: 'CREDIT_FAILURE', value: true });
                dispatch({ type: CheckOut.updateDepositInfo, value: false })
                dispatch({ type: "UPDATE_CREDITCHECK_MESSAGE", value: "security freeze"})
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.result) && InHomeUtils.isNotNull(response.data.result.reason) && response.data.result.reason === "FAILURE" && response.data.result.additionalinfo && response.data.result.additionalinfo.indexOf("SSN") === -1) {
                dispatch({ type: CheckOut.updateCreditFailAttempts, value: 1 })
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
                dispatch({ type: CheckOut.updateRTAStatus, value: false })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'required' })
                if(typeof wirelineLpCreditCheck !== "undefined" && InHomeUtils.isNotNull(wirelineLpCreditCheck) )
                {
                    wirelineLpCreditCheck('installation');
                }
                dispatch({ type: 'CREDIT_FAILURE', value: true });
                dispatch({ type: CheckOut.updateDepositInfo, value: false });
                dispatch({ type: "UPDATE_CREDITCHECK_MESSAGE", value: "non ssn failure"});
            }
            else if (response.status && response.status === 500) {
               let check_reattempt = store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.reattempt || 1
                if(reattempt < check_reattempt)
                {
                    reattempt = reattempt + 1
                    doCreditCheck(visitId, dispatch, creditCheckEncryptedValue, noSSNCheck, lqState, saveState, creditFailAttempts, tcChatInfo, appData, checkExternalCreditCheck, buildProductState,isVasVzProtect, contactPhoneNo, reattempt)
                    
                }
                else{
                dispatch({ type: CheckOut.updateCreditFailAttempts, value: 3 })
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })
                dispatch({ type: CheckOut.updateRTAStatus, value: false })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'required' })
                if(typeof wirelineLpCreditCheck !== "undefined" && InHomeUtils.isNotNull(wirelineLpCreditCheck) )
                    {
            wirelineLpCreditCheck('installation');
                    }
                dispatch({ type: 'CREDIT_FAILURE', value: true });
                dispatch({ type: CheckOut.updateDepositInfo, value: false });
                dispatch({ type: "UPDATE_CREDITCHECK_MESSAGE", value: null});
                creditInfoUpdate("FAILURE", tcChatInfo, "");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CC, 'CREDIT API Failure_CNT:' + creditFailAttempts, PAGEACTIVITY.UA));
           
            }
        }
            else {
                creditInfoUpdate("FAILURE", tcChatInfo, "");
                
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CC, 'CREDIT API Failure_CNT:' + creditFailAttempts, PAGEACTIVITY.UA));
            }
            
            if(noSSNCheck && !((response && response.data && response.data.icredit && response.data.icredit.depositinfo && response.data.icredit.depositinfo.finalbillamountrequired === "Y")|| (response && response.data && InHomeUtils.isNotNull(response.data.questionanswer) && response.data.questionanswer.length > 0))){ 
                noSSNcreditFailAttempts = noSSNcreditFailAttempts + 1;
                if(noSSNcreditFailAttempts <= 2){               
                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                }
                else if(noSSNcreditFailAttempts ===3){               
                    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                }                
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:doCreditCheck,errorMessage:${error.message}`;
              //  vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("LBO", "Checkout", error.message, "applogs", visitId, dispatch, true, "validateCredit");
                creditInfoUpdate("FAILURE", tcChatInfo);
            });
    } catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'doCreditCheck', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }

};

export const creditRefreshCRV = (visitId, dispatch, appData,creditFailAttempts, isFCPflow, isDoFlow) => {
    try {
        let creditCheck = apiUrl().creditRefresh;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Getting your installation dates", isLoaderImg: "loader" }
        });
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.CC,'CVC CREDIT REFRESH INVOKED',PAGEACTIVITY.UA));
        if (creditFailAttempts < 3) {
            api(creditCheck, 'GET').then(response => {
                //response= resp.creditResponse;
                //saveAction.smartSave(dispatch, visitId, "passive", true, false, appData.mon_no, MTN, true);
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    dispatch({ type: CheckOut.onUpdateCreditCheck, value: response.data });
                    //dispatch({ type: CheckOut.updateCRVNunmber, value: response.data.icredit.icreditrefno })
                    if (response.data.icredit.depositinfo.depositamount > 0) {
                        dispatch({ type: CheckOut.updateDepositInfo, value: true })
                        dispatch({ type: CheckOut.updateDepositAmount, value: response.data.icredit.depositinfo.depositamount })
                    } else {
                        dispatch({ type: CheckOut.updateDepositInfo, value: false })
                        dispatch({ type: CheckOut.updateDepositAmount, value: response.data.icredit.depositinfo.depositamount })
                    }
                    if(InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.result) && InHomeUtils.isNotNull(response.data.result.reason)){
                    if (response.data.result.reason === 'SUCCESS') {
                        tempSCData.detailPageName = "accord| info and credit- crd chk";
                        tempVzdlSCData.detail = "info and credit- crd chk";
                        tempSCData.installOptions = scDataDetails.initialInstallOptions;
                        tempSCData.creditCheck = "Pass";                       
                        tempVzdlSCData.creditCheck = "Pass";  
                        if(InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()){
                            if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                                tempSCData.flowName = "prospect accord seamless move";
                                tempVzdlSCData.flowName = "accord seamless move";
                            } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                                tempSCData.flowName = "prospect accord seamless move| mix match";
                                tempVzdlSCData.flowName = "accord seamless move + mix match";
                            }
                            else {
                                tempSCData.flowName = "prospect accord seamless move";
                                tempVzdlSCData.flowName = "accord seamless move";
                            }
                            setTimeout(()=>{
                                updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                            },1000); 
                            updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
                        }
                        else if(InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()){
                            if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                                tempSCData.flowName = "prospect accord move";
                                tempVzdlSCData.flowName = "accord move";
                            } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                                tempSCData.flowName = "prospect accord move| mix match";
                                tempVzdlSCData.flowName = "accord seamless move + mix match";
                            }
                            else {
                                tempSCData.flowName = "prospect accord move";
                                tempVzdlSCData.flowName = "accord move";
                            }
                            updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                            updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
                        }                        
                        else{
                            updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                            updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                        }
                        tempSCData.detailPageName = "accord| info and credit - autopay-offer selected";
                        tempVzdlSCData.detail = "info and credit - autopay-offer selected"; 
                        updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "detailPageName");
                        setTimeout(()=>{
                            tempVzdlSCData.detail = "accord install tos and summary install";
                            updateVzdlSCCustomEvent("pfbandAutoPayLoad", "pageViewOmni", "detail");
                        },2000)    
                        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
                        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })

                        //creditInfoUpdate("SUCCESS", tcChatInfo, response.data.icredit.icreditrefno);
                    }
                    else if (response.data.result.reason === 'FAILURE') {

                        // dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts + 1 }) // Commented since its increasing the count on page refresh which in turn making the CC section to lock as per latest changes.
                        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })

                        //Check If Final Bill Required
                        if (response.data.icredit.depositinfo.finalbillamountrequired === "Y") {
                            dispatch({ type: CheckOut.updateFinalBillStatus, value: true })
                            dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                        }
                        //if RTA Q's required                
                        else if (InHomeUtils.isNotNull(response.data.questionanswer) && response.data.questionanswer.length > 0) {
                            let rtadata = []
                            response.data.questionanswer.map(obj => { return rtadata.push({ questionnumber: obj.questionnumber, choicenumber: 0 }) })
                            dispatch({ type: CheckOut.updateRTAQs, value: { rtaquesionarrie: response.data.questionanswer, rtadata: rtadata } })
                            dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                            dispatch({ type: CheckOut.updateRTAStatus, value: true })

                        }
                        else {
                            dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'required' })
                            if(typeof wirelineLpCreditCheck !== "undefined" && InHomeUtils.isNotNull(wirelineLpCreditCheck) )
        {
            wirelineLpCreditCheck('installation');
        }
                            dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                            dispatch({ type: CheckOut.updateDepositInfo, value: false })
                        }
                        //creditInfoUpdate("FAILURE", tcChatInfo, response.data.icredit.icreditrefno);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.CC,'CREDIT CHECK FAILED_CNT:'+ creditFailAttempts,PAGEACTIVITY.UA));
                    }
                }
                } else {
                    //creditInfoUpdate("FAILURE", tcChatInfo, "");
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.CC,'CREDIT REFRESH API Failure_CNT:'+ creditFailAttempts,PAGEACTIVITY.UA));
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
                .catch(error => {
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    let errorMsg = `MethodName:doCreditCheck,errorMessage:${error.message}`;
                   // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                    logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                    errorAction("LBO", "Checkout", error.message, "applogs", visitId, dispatch, true, "validateCredit");
                    //creditInfoUpdate("FAILURE", tcChatInfo);
                });
        }
        else {
            dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts + 1 })
            dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
            dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
            dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
            dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
            dispatch({ type: CheckOut.updateRTAStatus, value: false })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
    } catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'doCreditCheck', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }

};

export const doCreditAssessment = (dispatch, isFCPflow, isDoFlow,isVasVzProtect,visitId) => {
    try {        
        let creditCheck = apiUrl().creditAssessment;

        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });

        api(creditCheck, 'GET').then(response => {
            dispatch({
                type: MTNValidation.updateisAssessmentRequired,
                value: false
            });
            //response= resp.creditResponse;  
            //response={"meta":{"code":200.01,"description":" creditFiosAssessment Details Completed successfully .","timestamp":"Fri Mar 27 06:56:43 UTC 2020"},"data":{"result":{"code":"0","reason":"SUCCESS","additionalinfo":"Prospect order approved","internalnotification":"(ZZ) CW Prospect order approved (Today's Date 03-27-20)","isretryallowed":false},"icredit":{"icreditrefno":1000085577,"depositinfo":{"depositamount":0,"finalbillamountrequired":"","finalamount":443.66,"finalbillacctn":"","finalbillaccid":""}},"questionanswer":[],"isexternalcredit":"N","isrddeligible":"N","basicdenied":"","nonbasicdenied":"","tolldenied":"","netverifydetails":{"netverifyeligible":"N","netverifyurl":"","netverifysessionid":"","netverifydecision":""}}};         
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: CheckOut.onUpdateCreditCheck,
                    value: response.data
                });
                dispatch({
                    type: CheckOut.updateCRVNunmber,
                    value: response.data.icredit.icreditrefno
                })
                if (response.data.result.reason === 'SUCCESS') {
                    tempSCData.detailPageName = "accord| info and credit - billinfo| vzw mtn credit success";
                    tempVzdlSCData.detail = "info and credit - billinfo vzw mtn credit success";
                    dispatch({
                        type: CheckOut.updateBAUCC,
                        value: false
                    })
                }
                else if (response.data.result.reason === 'FAILURE') {
                    tempSCData.detailPageName = "accord| info and credit - billinfo| vzw mtn credit fail";
                    tempVzdlSCData.detail = "info and credit - billinfo vzw mtn credit fail";
                    dispatch({
                        type: CheckOut.updateBAUCC,
                        value: true
                    })
                }
                if(isVasVzProtect && InHomeUtils.isNotNull(response.data.icredit) && InHomeUtils.isNotNull(response.data.icredit.wirelessInfo) && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo)  && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo.strVCustID) && InHomeUtils.isNotEmpty(response.data.icredit.wirelessInfo.strVAccID)){
                    getWirelessProductsVasPromo(dispatch,visitId,response.data.icredit.wirelessInfo.strVCustID,response.data.icredit.wirelessInfo.strVAccID)
                }
            }
            else {
                tempSCData.detailPageName = "accord| info and credit - billinfo| vzw mtn credit fail";
                tempVzdlSCData.detail = "info and credit - billinfo vzw mtn credit fail";
                dispatch({
                    type: CheckOut.updateBAUCC,
                    value: true
                })
            }
            if(InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()){
                if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                    tempSCData.flowName = "prospect accord seamless move";
                    tempVzdlSCData.flowName = "accord seamless move";
                } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                    tempSCData.flowName = "prospect accord seamless move| mix match";
                    tempVzdlSCData.flowName = "accord seamless move + mix match";
                }
                else {
                    tempSCData.flowName = "prospect accord seamless move";
                    tempVzdlSCData.flowName = "accord seamless move";
                }
                updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
            }
            else if(InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()){
                if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
                    tempSCData.flowName = "prospect accord move";
                    tempVzdlSCData.flowName = "accord move";
                } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
                    tempSCData.flowName = "prospect accord move| mix match";
                    tempVzdlSCData.flowName = "accord seamless move + mix match";
                }
                else {
                    tempSCData.flowName = "prospect accord move";
                    tempVzdlSCData.flowName = "accord move";
                }
                updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
            }           
            else{
                updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
            }  
            
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {                
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:doCreditAssessment,errorMessage:${error.message}`;
               // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({
                    type: CheckOut.updateBAUCC,
                    value: true
                })
            });
    } catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'doCreditAssessment', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    } 

}

const getCreditRequest = (creditCheckEncryptedValue, noSSNCheck, checkExternalCreditCheck) => {
    try {
        let request = {
            client: {
                name: 'vzcom',
                clientid: 'vzcom'
            },
            data: {
                creditinfo: {
                    dob: creditCheckEncryptedValue.protected_dob,
                    ssn: creditCheckEncryptedValue.protected_ssn,
                    dobkeyid: creditCheckEncryptedValue.key_id,
                    dobphase: creditCheckEncryptedValue.phase,
                    ssnkeyid: (noSSNCheck ? "" : creditCheckEncryptedValue.key_id),
                    ssnphase: (noSSNCheck ? "" : creditCheckEncryptedValue.phase),
                    idtype: '',
                },
                externalpermitted: checkExternalCreditCheck,
                affiliateshare: false,
                requesteidquestions: 'y',
                ipaddress: '127.0.0.0',
                isprepaidfiosindicator: false
            }
        }
        return JSON.stringify(request);
    } catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'getCreditRequest', ex);
    }

}

export const fNameErr = (status, dispatch) => {
    dispatch({ type: FinalBill.fNameErr, value: status })
};
export const lNameErr = (status, dispatch) => {
    dispatch({ type: FinalBill.lNameErr, value: status })
};
export const cTypeErr = (status, dispatch) => {
    dispatch({ type: FinalBill.cTypeErr, value: status })
};
export const cNumErr = (status, dispatch) => {
    dispatch({ type: FinalBill.cNumErr, value: status })
};
export const cVVErr = (status, dispatch) => {
    dispatch({ type: FinalBill.cVVErr, value: status })
};
export const expMonthErr = (status, dispatch) => {
    dispatch({ type: FinalBill.expMonthErr, value: status })
};
export const expYearErr = (status, dispatch) => {
    dispatch({ type: FinalBill.expYearErr, value: status })
};

export const cityErr = (status, dispatch) => {
    dispatch({ type: FinalBill.cityErr, value: status })
};

export const streetErr = (status, dispatch) => {
    dispatch({ type: FinalBill.streetErr, value: status })
};

export const stateValErr = (status, dispatch) => {
    dispatch({ type: FinalBill.stateValErr, value: status })
};
export const zipErr = (status, dispatch) => {
    dispatch({ type: FinalBill.zipErr, value: status })
};


export const getVzId = (visitId, dispatch) => {
    try {
        let getVzIdUrl = apiUrl().getVZID;
        api(getVzIdUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                InHomeUtils.isNotNull(response.meta.code === 400.01)) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC,
                    'getVzId INTERNAL ERROR', PAGEACTIVITY.UA));
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                InHomeUtils.isNotNull(response.meta.status)) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC,
                    'getVzId API Error', PAGEACTIVITY.UA));
            }
            dispatch({
                type: 'GENERATE_VZID',
                value: response
            });
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:getVzId,errorMessage:${error.message}`;
               // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("ERROR", "Checkout", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'getVzId', ex);
    }
};
export const getVZIdUpdated = (status, dispatch) => {
    dispatch({ type: 'VZIDUPDATED', value: status })
};

export const checkSatelliteEligible = (dispatch, lqQualdetails, visitId) => {
    try {
        let satelliteQualified = 'N';
        let isFiosTVQualified = false;
        let isOntSelfInstallCapable = false;
        if (InHomeUtils.isNotNull(lqQualdetails) && InHomeUtils.isNotNull(lqQualdetails.getBroadbandAvailabilityResult) &&  InHomeUtils.isNotNull(lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)) {
            let fttpCapabilityDetails = lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR;
            if (InHomeUtils.isNotNull(fttpCapabilityDetails.fiosTVQualified ) && fttpCapabilityDetails.fiosTVQualified === 'Y') {
                isFiosTVQualified = true;
            }
       
        
            let fttpAvailabilityDetails = lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR;
            if (InHomeUtils.isNotNull(fttpAvailabilityDetails.ontSelfInstallCapable) && fttpAvailabilityDetails.ontSelfInstallCapable === 'Yes') {
                isOntSelfInstallCapable = true;
            }
            if (InHomeUtils.isNotNull(fttpAvailabilityDetails.ontAGR)  && fttpAvailabilityDetails.ontAGR.length > 0) {
                let srvcs = fttpAvailabilityDetails.ontAGR[0].portDetailAGR;
                for (let i = 0; i < srvcs.length; i++) {
                    if (InHomeUtils.isNotNull(srvcs[i].existingOntWiring) && srvcs[i].existingOntWiring === 'ETHERNET' && isFiosTVQualified && isOntSelfInstallCapable) {
                        satelliteQualified = "Y";
                    }
                }
            }
        }
        dispatch({ type: CheckOut.satelliteEligible, value: satelliteQualified })
    } catch (ex) {
        catchJSException('Checkout', visitId, 'checkSatelliteEligible', ex);
    }
};

export const satelliteClick = (dispatch, optionType) => {
    dispatch({ type: CheckOut.satelliteOption, value: optionType })
}

export const satelliteClickupdate = (dispatch,satellitevalue) => {
    dispatch({type : CheckOut.satelliteClick, value : satellitevalue })
}

export const satelliteContinueClick = (dispatch, action, isFCPflow, isDoFlow) => {
    dispatch({ type: CheckOut.satelliteClick, value: action })
    dispatch({ type: CheckOut.updateSatelliteAccordionStatus, value: 'completed' })

    tempSCData.detailPageName = "accord| info and credit- crd chk";
    tempVzdlSCData.detail = "info and credit- crd chk";
    
    if(InHomeUtils.isFlowTypeCheckMoves() && InHomeUtils.flowCheckforSeamless()){
        if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
            tempSCData.flowName = "prospect accord seamless move";
            tempVzdlSCData.flowName = "accord seamless move";
        } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
            tempSCData.flowName = "prospect accord seamless move| mix match";
            tempVzdlSCData.flowName = "accord seamless move + mix match";
        }
        else {
            tempSCData.flowName = "prospect accord seamless move";
            tempVzdlSCData.flowName = "accord seamless move";
        }
        updateSCcustomEvent("checkoutInitMoves", "ddCheckoutEvent", "detailPageName");
    }
    else if(InHomeUtils.isFlowTypeCheckMoves() && !InHomeUtils.flowCheckforSeamless()){
        if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && InHomeUtils.isFCPInProfile()) {
            tempSCData.flowName = "prospect accord move";
            tempVzdlSCData.flowName = "accord move";
        } else if ((InHomeUtils.isNotNull(isFCPflow) && isFCPflow) && !InHomeUtils.isFCPInProfile()) {
            tempSCData.flowName = "prospect accord move| mix match";
            tempVzdlSCData.flowName = "accord seamless move + mix match";
        }
        else {
            tempSCData.flowName = "prospect accord move";
            tempVzdlSCData.flowName = "accord move";
        }
        updateSCcustomEvent("checkoutInitNonSeamless", "ddCheckoutEvent", "detailPageName");
    }
    /*    
    else{
        updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
        setTimeout(()=>{
            updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
        },1000); 
    }*/
}
export const getTos = (visitId, dispatch) => {
    try {
        var host = window.location.host;        

        let getVzIdUrl = apiUrl().getTermsAEM;
        
        api(getVzIdUrl, 'GET', '').then(response => {
            if(InHomeUtils.isNotNull(response)){
            dispatch({ type: 'GET_TOS', value: response });
            }
            // else 
            // {
            //     getVzIdUrl = '/personal/cas/getorderingtos.model.json';
            //     api(getVzIdUrl, 'GET', '').then(response => {
            //         if(InHomeUtils.isNotNull(response)){
            //         dispatch({ type: 'GET_TOS', value: response });
            //         }
            //     });
            // }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:getTos,errorMessage:${error.message}`;
               // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("ERROR", "Checkout", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'getTos', ex);
    }
};

// export const getCentralAgreementTos = async (visitId, dispatch) => {
//     try {
//         var host = window.location.host;
//         const url = '/inhome/getCentralAgreementTermsAEM';
//        // let getVzIdUrl = apiUrl().getCentralAgreementTermsAEM;        
//         api(url, 'GET', '').then(response => {
//             if(InHomeUtils.isNotNull(response)){
//               if(InHomeUtils.isNotNull(response?.legalDocumentDetails)){
//                 dispatch({ type: 'GET_CENTRALAGREEMENT_TOS', value: response });
//               }
              
//             }
            
//         })
//         .catch(error => {
//             let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
//             let errorMsg = `MethodName:getCentralAgreementTermsAEM,errorMessage:${error.message}`;
//             // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
//             logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
//             errorAction("ERROR", "Checkout", error.message, "applogs", visitId, dispatch, false, "");
//         });
//     }
//     catch (ex) {
//         catchJSException('Checkout', this.props.appState.visitId, 'getTos', ex);
//     }
// };

export const getCentralAgreementTos = async (visitId, dispatch) => {
    try {
        
        var host = window.location.host;
        let url='';
        
        if (host.indexOf("sit") > -1 || host.indexOf("nte3") > -1 || host.indexOf("nte1") > -1 || host.indexOf("stage") > -1 || host.indexOf("preprod") > -1) {
            url = window.location.href.indexOf('espanol') > -1 ? '/inhome/getCentralAgreementTermsSpanishAEM' :'/inhome/getCentralAgreementTermsAEM';
        }
        else{
            if(window.location.href.indexOf('http://localhost') > -1 || window.location.host.includes('www.verizon.com') > -1) {
                url = window.location.href.indexOf('espanol') > -1 ? apiUrl().getCentralAgreementTermsSpanishAEM :apiUrl().getCentralAgreementTermsAEM;               
            }
        }
        
       
        console.log("getCentralAgreementTos url",url)
        return new Promise((resolve, reject) => {
            api(url, 'GET', '').then(async response => {
                let orderedKeys = response;
                if (InHomeUtils.isNotNull(response) && response !== "") {            
                   
                    if(InHomeUtils.isNotNull(response?.legalDocumentDetails)){
                         dispatch({ type: 'GET_CENTRALAGREEMENT_TOS', value: response });
                    }
                }
                else {
                    let errorMsg = "AEM response not returned";
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    logKafka("ERROR", "getCentralAgreementTermsAEM", errorMsg, getErrorLogUrl, "applogs", visitId);
                    
                }
                resolve(orderedKeys);
            })
                .catch(error => {
                    let errorMsg = `MethodName:getCentralAgreementTermsAEM,errorMessage:${error.message}`;
                    logKafka("ERROR", "getCentralAgreementTermsAEM", errorMsg, getErrorLogUrl, "applogs", "");
                    vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
                });
        });
    }
    catch (ex) {
        catchJSException('getCentralAgreementTermsAEM', visitId, 'getCentralAgreementTermsAEM', ex);
    }
}

export const returnEquipmentClick = (dispatch,optionType) => {
    dispatch({ type: CheckOut.returnEquipmentOption, value: optionType })
};
export const updateFiabSelectedOption = (dispatch,fiabSelectedOption) => {
    dispatch({ type: CheckOut.fiabSelectedOption, fiabSelectedOption })
};

export const returnEquipmentContinueClick = (dispatch, action) => {
    dispatch({ type: CheckOut.returnEquipmentClick, value: action })
    dispatch({ type: CheckOut.updateReturnEquipAccordianStatus, value: 'completed' })
}
export const updateReturnEquipAccordian = (action, dispatch) => {
    dispatch({ type: CheckOut.updateReturnEquipAccordianStatus, value: action })
}

export const getFaqCheckout = (dispatch, visitId, pageName,faqaem,hoaFlag="N") => {
    try {
        let url = faqaem == "Y" ? apiUrl().getFaqAEM : (apiUrl().getFaq + '/' + pageName);

        api(url, 'GET', '').then(response => {
            if (faqaem == "Y") {
                    if (InHomeUtils.isNotNull(response) && response.items && response.items.length) {
                        let parsedResponse = [];
                        response.items.forEach(item => {
                            if(hoaFlag === "Y" && item.pagetype == "vecordering"){
                                parsedResponse.push(item);
                            }
                            if(item.pagetype == "buildproduct" && hoaFlag !== "Y"){
                                parsedResponse.push(item);
                            }
                            // if(item.pagetype == "checkout"){
                            //     parsedResponse.push(item);
                            // }
                        });
                        dispatch({ type: 'FAQ_CHECKOUT_CONTENT', value: parsedResponse });
                    }
            }
            else {
                if (InHomeUtils.isNotNull(response))
                dispatch({ type: 'FAQ_CHECKOUT_CONTENT', value: response });
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:getFaqCheckout,errorMessage:${error.message}`;
               // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'getFaqCheckout', ex);
    }
}
export const setXpsResumeDetails = (visitId, dispatch,personalInfoCompleted,creditCheckCompleted,addrID,isFCPflow, lqState = null, buildProductState = null) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        let url = apiUrl().getSmartCartPersonalInfo;
        let hoaFlow = lqState && lqState.lqResponse && lqState.lqResponse.hoaFlag && lqState.lqResponse.hoaFlag === "Y";
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                let respData = response.data;
                let isvalidConatctInfo = false;
                if (InHomeUtils.isNotNull(respData.firstName) && InHomeUtils.isNotNull(respData.lastName)  && InHomeUtils.isNotNull(respData.eMail) && InHomeUtils.isNotNull(respData.mtn) && InHomeUtils.isNotNull(respData.billingAddress)) {
                    if (respData.firstName !== "" && respData.lastName !== "" && respData.eMail !== "" && respData.mtn !== "" && respData.billingAddress !== "" && respData.firstName.toUpperCase() !== "XPS" && respData.lastName.toUpperCase() !== "XPS") {
                        isvalidConatctInfo = true;
                    }
                }
                const isRetailFiosReferralCheck = window.sessionStorage.getItem('fiosReferralFlow');
                if ((personalInfoCompleted && isvalidConatctInfo && creditCheckCompleted) || ((personalInfoCompleted && isvalidConatctInfo) || creditCheckCompleted)) {
                    let contactInfo = {};
                    contactInfo = {
                        "fName": respData.firstName,
                        "lName": respData.lastName,
                        "isValidfName": true,
                        "isValidlName": true,
                        "eMailId": respData.eMail,
                        "isValidMail": true,
                        "isValidTN": true,
                        "phoneNo": {
                            "ph1": respData.mtn
                            // "ph2": respData.mtn.slice(3, 6),
                            // "ph3": respData.mtn.slice(6, 10),
                        },
                        "isContactInfoValidated": true,
                    }
                    let billingAdrInfo = {};
                    billingAdrInfo = {
                        "isValidBillingAddress": true,
                        "billingAddress": respData.billingAddress,
                        "isBillingInfoValidated": true
                    }
                    dispatch({ type: CheckOut.updateNameInfo, value: contactInfo });
                    dispatch({ type: CheckOut.updateContactInfo, value: contactInfo });
                    dispatch({ type: "UPDATE_PHONE", value: contactInfo.phoneNo });
                    dispatch({ type: CheckOut.updateBillingAddrInfo, value: billingAdrInfo });

                    if (!creditCheckCompleted && !hoaFlow) {
                        validateVZWOfferEligibility(dispatch, respData.mtn, visitId, false, addrID,isFCPflow, lqState&&lqState.doFlowDetails.isDoFlow, lqState, buildProductState,"creditCheck",respData.firstName,respData.lastName,respData.eMail);
                        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'required' })
                    }
                    else if (!creditCheckCompleted) {
                        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
                    }
                    
                    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })
                    
                    
                    if(creditCheckCompleted)
                    {        
                        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })}
                    }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("LBO", "PERSONALINFOERROR", response.meta.description, "applogs", visitId, dispatch, true, "PERSONALINFOERROR");
                vzdlErrorUpdate(response.meta.code,"PERSONALINFOERROR");
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:setXpsResumeDetails,errorMessage:${error.message}`;
               // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("ERROR", "SETXPSRESUMEDETAILS", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('Checkout', this.props.appState.visitId, 'setXpsResumeDetails', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const targetLofTosEnable = (action, dispatch) => {
    dispatch({ type: "LOF_TOSENABLE", value: action })
}

export const dispatchSDDEvents =(dispatch,autoPay,servicesOrdered,PrevSelectedProudct,visitId,pfbautopayFlag, isAutopayPFBEnhancement=false) => {
try{
    dispatch({ type: CheckOut.onSetDueDate, value: true });
    dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'change' })
    if(autoPay === "HOA")  {
         dispatch({ type: CheckOut.updateAutoPayAccordionStatus, value: 'completed' })
        }
    dispatch({
        type: 'RESET_DUEDATE_MESSAGE',
        value:{
            resetDD :false,
            attemptExceeded:false
        }
    });

    //socAction.fetchPostSoc(dispatch, visitId);
    if(InHomeUtils.isNotNull(PrevSelectedProudct) && InHomeUtils.isNotNull(servicesOrdered) && (servicesOrdered !== PrevSelectedProudct.PrevSelectedProudct))
    {
        dispatch({ type: CheckOut.PrevSelectedProd, value: servicesOrdered })
    }
    if(autoPay === 'required'){
        updateSCcustomEvent("pfbandAutoPayLoad","ddCheckoutEvent","");
        tempVzdlSCData.autoPay = "Enabled";
        tempVzdlSCData.events = "event78";
        if(pfbautopayFlag){
            updateSandboxIdValue( isAutopayPFBEnhancement ? "fios_apbopt" : "fios_c_apbopt" )
            updateVzdlSCCustomEvent("pfbandAutoPayLoadReskin", "pageViewOmni", "notification,events", false, "", false, "great news - You will be saving $10/mo for being enrolled in both auto pay & paper free billing");
        }     
         else
        updateVzdlSCCustomEvent("pfbandAutoPayLoad", "pageViewOmni", "events");
    }
    else{
        updateSCcustomEvent("installandtosLoad", "ddCheckoutEvent", "");
        updateVzdlSCCustomEvent("installandtosLoad", "pageViewOmni", "");
    }

}catch (ex) {
    catchJSException('Checkout', visitId, 'action_dispatchSDDEvents', ex);
   
}
}
//movechange
export const setMovesCheckoutExp = (visitId,dispatch) => {
    // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    let url = apiUrl().MoveCheckoutExperience;
    return new Promise((resolve, reject) => {
    api(url, 'GET', '').then(response => {
        if (response.meta.code === 200.0 ||response.meta.code === 200.01||response.meta.code === 200.02 && response.data !==null && response.data!== undefined) {
            let respData=response.data;
                let contactInfo = {};
                let mvCheckout={};
                // "ph2": respData.contactInfo.mtn ? respData.contactInfo.mtn.slice(3,6) : "",
                //         "ph3": respData.contactInfo.mtn ? respData.contactInfo.mtn.slice(6,10) : "",
                let mtn = respData.contactInfo.mtn;
                if(respData.contactInfo.mtn && respData.contactInfo.mtn.length === 10) {
                    let mtnArr = typeof mtn === 'string' ? [...mtn] : [...mtn.toString()];
                    mtnArr.splice(3,0,'.');
                    mtnArr.splice(7,0,'.');
                    mtn = mtnArr.join('');
                }
                contactInfo = {
                    "fName":respData.contactInfo.firstName,
                    "lName": respData.contactInfo.lastName,               
                    "isValidfName": respData.contactInfo.firstName, 
                    "isValidlName": respData.contactInfo.lastName,              
                    "eMailId": respData.contactInfo.eMail,              
                    "isValidMail": respData.contactInfo.eMail,
                    "isValidTN": respData.contactInfo.mtn,
                    "phoneNo": {
                        "ph1": mtn ? mtn : "",                        
                    }      
                }
            let returnequip=[{"serialNumber" : 100000 , "name" : "Media Client", "price":115} , {"serialNumber" : 100000 , "name" : "Media Client", "price":115}];
           
           mvCheckout={
            //    "autopayInProfile":respData.autopayInProfile,
            //    "PFBInProfile":respData.PFBInProfile,
               "depositInProfile":respData.profileDeposit,
               "depositAmount":respData.depositAmount,
               "returnEquipment":respData.returnEquipments 
           }
           dispatch({ type: CheckOut.updateNameInfo, value: contactInfo });
            dispatch({ type: CheckOut.updateContactInfo, value: contactInfo });
            dispatch({ type: "UPDATE_PHONE", value: contactInfo.phoneNo});
            dispatch({ type: CheckOut.mvCheckout, value: mvCheckout});

         // dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
           dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }); 
           resolve(response.data);
    
} })
    .catch(error => {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        errorAction("ERROR", "setMovesCheckoutExp", error.message, "applogs", visitId, dispatch, false, "");
  // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
    });  
});
};
//movechange
export const setMovesCheckoutExperienceFrmJSON = (visitId,dispatch) => {
    // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    var checkoutJSON = require('./../containers/move/checkoutExpJson.json');
    let url = apiUrl().getCartAcc;
    api(url, 'GET', '').then(response => {
       // alert(response);
        //if (response.meta.code === 200.02 && response.data !==null && response.data!== undefined) {
           // let respData=response.data;
           if (response.meta.code === 500.01) {
           let respData=checkoutJSON.data;
                let contactInfo = {}; 
                let mvCheckout={};      
                contactInfo = {
               "fName":respData.contactInfo.firstName,
               "lName": respData.contactInfo.lastName,               
               "isValidfName": respData.contactInfo.firstName,
               "isValidlName": respData.contactInfo.lastName,              
               "eMailId": respData.contactInfo.eMail,              
               "isValidMail": respData.contactInfo.eMail,
               "isValidTN": respData.contactInfo.mtn,
               "phoneNo": {
                   "ph1": respData.contactInfo.mtn && respData.contactInfo.mtn.slice(0,3),
                   "ph2": respData.contactInfo.mtn && respData.contactInfo.mtn.slice(3,6),
                   "ph3": respData.contactInfo.mtn && respData.contactInfo.mtn.slice(6,10),
             }      
           }
           let returnequip=[{"serialNumber" : 100000 , "name" : "Media Client", "price":115} , {"serialNumber" : 100000 , "name" : "Media Client", "price":115}];
           mvCheckout={
            // "autopayInProfile":respData.autopayInProfile,
            // "PFBInProfile":respData.PFBInProfile,
            "depositInProfile":respData.profileDeposit,
            "depositAmount":respData.depositAmount,
            "returnEquipment":respData.returnEquipments 
        }
        dispatch({ type: CheckOut.updateNameInfo, value: contactInfo });
        dispatch({ type: CheckOut.updateContactInfo, value: contactInfo });
        dispatch({ type: "UPDATE_PHONE", value: contactInfo.phoneNo});
        dispatch({ type: CheckOut.mvCheckout, value: mvCheckout});

          // dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }); 
    
} })
    .catch(error => {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        errorAction("ERROR", "setMovesCheckoutExp", error.message, "applogs", visitId, dispatch, false, "");
       // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
    });  
}

export const updateNonMTNTrackerInCart = (visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('checkout', visitId, 'updateNonMTNTrackerINCart', "Inside updateNonMTNTrackerINCart"));
        
        let url = apiUrl().updateCartAcc + '/' + visitId;
        let request = {
            productId: "R3508",
            productType: "DUMMY",
            quantity: "1",
            serviceType: "DATA",
            status: "add"
        }
       
        api(url, 'POST', JSON.stringify(request)).then(resp => {
            if (InHomeUtils.isNotNull(resp) && InHomeUtils.isNotNull(resp.meta) && InHomeUtils.getIndexOf(resp.meta.code, '200')) {
                dispatch({ type: 'NON_MTN_TRACKER_UPDATED', value: true });
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            logOtherInfo(detailsInfo('checkout', visitId, 'updateNonMTNTrackerINCart', "updateNonMTNTrackerINCart - exception"));
           // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            let errorMsg = `MethodName:updateNonMTNTrackerINCart,errorMessage:${error.message}`;
            logKafka("ERROR", "updateNonMTNTrackerINCart", errorMsg, getErrorLogUrl, "applogs", visitId);
        });
    }
    catch (ex) {
        catchJSException('checkout', visitId, 'updateNonMTNTrackerINCart', ex);
    }
    
}

export const getDropOffStores = (visitId, dispatch, zipCode) => {
    try {

        logOtherInfo(detailsInfo('CheckoutPD', visitId, 'getDropOffStores', "get Drop Off Stores"));
        let zip = zipCode ? zipCode : 71101;
        let url = apiUrl().disconnectstoredetails + '?zip=' + zip;

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.getClosestStoreDropLoc) && response.response.getClosestStoreDropLoc.record) {

                let storesList = [];
                
                response.response.getClosestStoreDropLoc.record.map(obj => {
                    return (
                        storesList.push({ addressL1: obj.store.location.addressline1, addressL2: `${obj.store.location.city} ${obj.store.location.state} ${obj.store.location.zip}`, distance: obj.store.approxmiles, contactNo: obj.store.telephone, openHrs: obj.store.operatinghours1, ownership: obj.storeownership }))
                })
                
            dispatch({
                type: 'STORE_DETAILS',
                value: storesList
            });
            
            }
           
           
            
        })
            .catch(error => {
                logOtherInfo(detailsInfo('CheckoutPD', visitId, 'getDropOffStores', "Exception is: " + error.message));

            });
    }
    catch (ex) {
        catchJSException('CheckoutPD', visitId, 'getDropOffStores', ex);
    }
}
export const EmergencyNotificationConsentRequired = (value, dispatch) => {
    dispatch({ type: 'EMERGENCY_NOTIFICATION_CONSENT_REQUIRED', value: value });
}

export const EmergencyNotificationConsent = (value, dispatch) => {
    dispatch({ type: 'EMERGENCY_NOTIFICATION_CONSENT', value: value });
}

export const EmergencyNotificationStates = (value, dispatch) => {
    dispatch({ type: 'EMERGENCY_NOTIFICATION_STATES', value: value });
}

export const EmergencyNotificationVroom = (value, dispatch) => {
    dispatch({ type: 'EMERGENCY_NOTIFICATION_RESTRICT_VROOM', value: value });
}

export const getWirelessProductsVasPromo = (dispatch, visitId, strVCusID,strVAccID) => {					
    try {
        logOtherInfo(detailsInfo('checkout', visitId, 'getWirelessProductsVasPromo', "Inside getWirelessProductsVasPromo"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        
        let url = apiUrl().getWirelessProduct;
        let request = {
            "strVCustID":strVCusID,
            "strVAccID":strVAccID,
        };

        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (InHomeUtils.isNotNull(response.data) && response.data.updateCart) {
                    url = apiUrl().getCartAcc + '/' + visitId;
                    api(url, 'GET', "").then(resp => {
                        if (InHomeUtils.isNotNull(resp) && InHomeUtils.isNotNull(resp.meta) && InHomeUtils.getIndexOf(resp.meta.code, '200')) {
                            dispatch({
                                type: "UPDATE_CART",
                                value: {
                                    cartResponse: resp.data.cartTierPricing,
                                    cartHeader: getCartHeader(resp.data.cartTierPricing.tierContent, visitId),
                                    cartData: getCartData(resp.data.cartTierPricing.tierContent, visitId),
                                    cartOrderDetail: resp.data.orderDetail,
                                    cartOrderProperty: InHomeUtils.isNull(resp.data.cartOrderProperty) ? null : resp.data.cartOrderProperty
                                }
                            });
                        }
                    })
                }
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        .catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            logOtherInfo(detailsInfo('checkout', visitId, 'getWirelessProductsVasPromo', "getWirelessProductsVasPromo - exception"));
           // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            let errorMsg = `MethodName:getWirelessProductsVasPromo,errorMessage:${error.message}`;
            logKafka("ERROR", "getWirelessProductsVasPromo", errorMsg, getErrorLogUrl, "applogs", visitId);
        });
    }
    catch (ex) {
        catchJSException('checkout', visitId, 'getWirelessProductsVasPromo', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

export const getScreeningInfo = (dispatch, visitId, response) => {
    try {
        logOtherInfo(detailsInfo('checkout', visitId, 'getScreeningInfo', "Inside getScreeningInfo"));
        let screeningSet = Object.keys(response).length > 0  && Object.keys(response).includes('ScreeningSet') && response['ScreeningSet'].disclaimer;
        if(screeningSet) {
            screeningSet = screeningSet.replace('<p>', '').trim();
            screeningSet = screeningSet.replace('</p>', '').trim();
            dispatch({ type: 'SCREENING_CHOICE_SET', value: screeningSet });
        }
        let screeningQuestionaire = Object.keys(response).filter(row =>
            row.includes('ScreeningQtn') || row.includes('ScreeningAns')
        ).reduce((obj, row) => {
            let index = response[row].productid.split('_').length > 1 && response[row].productid.split('_')[1];
            if(!obj[index]) {
                obj[index] = {};
            }
            if(row.includes('Qtn')) {
                obj[index]['Q'] = response[row].disclaimer;
            }
            else {
                let options = response[row].disclaimer;
                options = options.replace('<p>', '').trim();
                options = options.replace('</p>', '').trim();
                obj[index]['O'] = options;
            }
            return obj;
        }, {});
        if(screeningQuestionaire) {
            dispatch({ type: 'SCREENING_QUESTIONAIRE', value: screeningQuestionaire });
        }
    }
    catch (ex) {
        catchJSException('checkout', visitId, 'getScreeningInfo', ex);
    }
}

export const enableScreeningButton = (value, dispatch, visitId) => {
    dispatch({ type: 'SCREENING_ENBALE_BUTTON', value: value });
}

export const updateScreeningChoice = (value, dispatch, visitId) => {
    dispatch({ type: 'SCREENING_SELECTED_OPTION', value: value });
}

export const setDisplayScreeningTaggingFired = (value, dispatch) => {
    dispatch({ type: 'SCREENING_DISPLAY_TAGGING_FIRED', value: value });
}

export const setClickScreeningTaggingFired = (value, dispatch) => {
    dispatch({ type: 'SCREENING_CLICK_TAGGING_FIRED', value: value });
}

export const focusOnCalendar = (value, dispatch, visitId) => {
    dispatch({ type: 'FOCUS_CALENDAR', value: value });
}

export const setClickMNHAutopayTaggingFired = (value, dispatch) => {
    dispatch({ type: 'MNH_AUTOPAY_OPTION_CLICK_TAGGING_FIRED', value: value });
}

export const reserveSIDueDate = (value, dispatch) => {
    dispatch({ type: CheckLQ.MNHReserveSIDueDate, value: value });
}

export const mnhCreditPfbAutoPay = (dispatch) => {
    dispatch({ type:CheckLQ.MNHPFBAUTOPAY,value:true});
    dispatch({ type: CheckOut.updateAutoPayAccordionStatus, value: "completed" })
}

export const cancelPropensity = (visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('checkout', visitId, 'cancelPropensity', "Inside cancelPropensity"));
        
        let url = apiUrl().cancelpropensity;
        dispatch({ type: 'CANCEL_PROPENSITY_CALL_INITIATED', value: true });
        api(url, 'GET', ).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200.01')) {
                dispatch({ type: 'CANCEL_PROPENSITY_CALL_SUCCESS', value: true });
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            logOtherInfo(detailsInfo('checkout', visitId, 'cancelPropensity', "cancelPropensity - exception"));
            let errorMsg = `MethodName:cancelPropensity,errorMessage:${error.message}`;
          //  vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            logKafka("ERROR", "cancelPropensity", errorMsg, getErrorLogUrl, "applogs", visitId);
        });
    }
    catch (ex) {
        catchJSException('checkout', visitId, 'cancelPropensity', ex);
    }
}

export const setCheckoutNotificationDisplay = (dispatch, value) => {
    dispatch({ type: 'DISPLAY_PENDING_CHECKOUT', value: value });
};

export const getACPDetails = (dispatch, queryValue = '') =>{
    try{
        let url = apiUrl().wlCustomerCheckoutInfo + queryValue;
        api(url, 'GET', ).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200.01')) {
                if(response.data){
                    dispatch({type: "ACP_DETAILS_UPDATE", value: response.data});
                    dispatch({type: "ACP_CREDIT_CHECK_UPDATE", value: response.data});
                }
            }
        })
        .catch(error => {
           console.log(error);
        });
    }
    catch (ex) {
        console.log(ex);
    }
}
export const getMnhsignininfodetails = (dispatch) =>{
    const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";

    try{
        let url = apiUrl().ssoMHGetName ;
        api(url, 'GET', ).then(response => {
            console.log("mnhdetail", response)
            if (InHomeUtils.isNotNull(response) && !isFiOSFlag && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200.01')) {
                if(response.data){
                    dispatch({type: "ACP_DETAILS_UPDATE", value: response.data});
                    dispatch({ type: 'SET_MNH_STATUS', value: 'Y' });
                }
            }
        })
        .catch(error => {
           console.log(error);
        });
    }
        catch (ex) {
            console.log(ex);
        }
    
}

export const getcustomerdetailsresponse = (dispatch) =>{
    //const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";

    try{
        let url = apiUrl().ssoMHGetCustomerDetails ;
        api(url, 'GET', ).then(response => {
            console.log("mnhdetail", response)
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200.01')) {
                if(response.data){
                    dispatch({type: "CUST_DETAILS_UPDATE", value: response.data});
                }
            }
        })
        .catch(error => {
           console.log(error);
        });
    }
        catch (ex) {
            console.log(ex);
        }
    
}




